// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/font/TwCenMTStd.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/font/TwCenMTStdSemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/font/TwCenMTStdSemiMedium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/font/TwCenMTStdItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/font/TwCenMTStdLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/font/TwCenMTStdBold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "TwCenMTStd-Regular";
  src: local("TwCenMTStd-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
@font-face {
  font-family: "TwCenMTStd-SemiBold";
  src: local("TwCenMTStd-SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}
@font-face {
  font-family: "TwCenMTStd-Medium";
  src: local("TwCenMTStd-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}
@font-face {
  font-family: "TwCenMTStd-SemiMedium";
  src: local("TwCenMTStd-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}
@font-face {
  font-family: "TwCenMTStd-Italic";
  src: local("TwCenMTStd-Italic"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
}
@font-face {
  font-family: "TwCenMTStd-Light";
  src: local("TwCenMTStd-Light"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
}
@font-face {
  font-family: "TwCenMTStd-Bold";
  src: local("TwCenMTStd-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("opentype");
}
body {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
}

body,
div,
span,
label,
input,
textarea,
a,
option,
li,
p,
th,
td,
button {
  font-family: TwCenMTStd-Regular !important;
}

select {
  border: 1px solid #111;
  border-radius: 3px;
  font-family: TwCenMTStd-Regular !important;
  margin: 0px 0px 8px 0px;
}

.header-border {
  border-top: 5px solid #c3d34f;
  z-index: 1001 !important;
}

@media only screen and (min-height: 800px) {
  .sidebar-footer {
    position: absolute;
    bottom: 15px;
    width: 100%;
  }
}
@media only screen and (min-height: 400px) {
  .admin-sidebar-footer {
    position: absolute;
    bottom: 15px;
    width: 100%;
  }
}
body > iframe {
  display: none;
}

.search {
  margin-right: 25px !important;
}

.filter {
  font-size: 32px !important;
  cursor: pointer;
}

.pr-16 {
  padding-right: 16px;
}

.pr-8 {
  padding-right: 8px;
}

.mr-10 {
  margin-right: 10px !important;
}

.mr-16 {
  margin-right: 16px !important;
}

.bg-white {
  background-color: #ffffff;
}

.hrmonth-chart .recharts-legend-wrapper {
  top: -45px !important;
  width: auto !important;
  right: 56px !important;
  min-width: unset !important;
}

.filter-popup .MuiPaper-root {
  min-height: 96.9px;
  width: 320px;
  border-radius: 8px !important;
  background-color: #241a2e !important;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.22) !important;
  overflow: unset !important;
  padding: 15px 0px 11px 16px;
  margin-top: 15px;
}
.filter-popup .mb-6 {
  margin-bottom: 6px;
}
.filter-popup .filter-text-grey {
  color: #979598 !important;
  font-size: 14px !important;
  letter-spacing: 0;
  line-height: 21px !important;
}
.filter-popup .filter-text {
  color: #ffffff !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
}
.filter-popup .reset-text {
  color: #c60c68 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  -webkit-text-decoration: underline solid #c60c68;
          text-decoration: underline solid #c60c68;
  cursor: pointer;
}
.filter-popup .scroll-box {
  max-height: 83vh;
  overflow-y: auto;
  padding-right: 16px;
}
.filter-popup .scroll-box .custom-field {
  margin-bottom: 8px;
}
.filter-popup .scroll-box .custom-field .select-button-filter {
  margin-top: 6px;
  width: 100%;
  background-color: #ffffff;
  justify-content: space-between;
  height: 40px;
  border-radius: 5px;
}
.filter-popup .scroll-box .custom-field .select-button-filter .filter-select-title {
  text-transform: capitalize;
  margin-left: 5px !important;
  color: black !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
}
.filter-popup .scroll-box .custom-field .select-button-filter .filter-select-count {
  text-align: center;
  display: flex;
  align-self: center;
}
.filter-popup .scroll-box .custom-field .select-button-filter .filter-select-count .filter-select-count-text {
  color: #0061ff !important;
  font-size: 16px !important;
  font-family: TwCenMTStd-SemiBold !important;
  margin-right: 5px !important;
}
.filter-popup .scroll-box .custom-field .select-button-filter .filter-select-count .select-arrow {
  fill: #171a33 !important;
}
.filter-popup .scroll-box .custom-field p {
  color: #ffffff !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 24px !important;
}
.filter-popup .scroll-box .custom-field .custom-input {
  width: 100%;
}
.filter-popup .scroll-box .custom-field .custom-input .MuiOutlinedInput-notchedOutline {
  border: unset !important;
}
.filter-popup .scroll-box .custom-field .custom-input .MuiInputBase-root {
  height: 43px !important;
  border-radius: 7px !important;
  background-color: #f8f8fa;
}
.filter-popup .scroll-box .custom-field .custom-input .MuiInputBase-root::before, .filter-popup .scroll-box .custom-field .custom-input .MuiInputBase-root::after {
  border-bottom: unset;
}
.filter-popup .scroll-box .custom-field .custom-input .MuiSelect-select {
  padding-right: 100px !important;
}
.filter-popup .scroll-box .custom-field .custom-input .MuiInputBase-input {
  padding: 13px 11px;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  color: #171a33;
}
.filter-popup .arrow-top {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  position: absolute;
  right: 15px;
  top: -7px;
  transform: rotate(225deg);
  background-color: #241a2e;
}
.filter-popup .pop-item {
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 32px;
  cursor: pointer;
}

.edit-popup .MuiPaper-root {
  min-height: 56.9px;
  min-width: 207px;
  border-radius: 8px !important;
  background-color: #241a2e !important;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.22) !important;
  overflow: unset !important;
  padding: 15px 16px 11px 16px;
}
.edit-popup .mb-6 {
  margin-bottom: 6px;
}
.edit-popup .arrow-top {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 15px;
  top: -7px;
  transform: rotate(225deg);
  background-color: #241a2e;
}
.edit-popup .pop-item {
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 32px;
  cursor: pointer;
}

.MuiTableContainer-root {
  box-shadow: unset !important;
  background-color: unset !important;
}

.employee-legent .opt-text {
  color: #171a33 !important;
  font-size: 14px !important;
  margin-left: 6px !important;
}
.employee-legent .opt-text2 {
  color: #171a33 !important;
  font-size: 15px !important;
  margin-left: 6px !important;
}
.employee-legent .opt-box {
  height: 16px;
  width: 16px;
}
.employee-legent .opt-box.rs {
  background-color: #c3d34f;
}
.employee-legent .opt-box.gs {
  background-color: #344A5C;
}
.employee-legent .opt-box.na {
  background-color: #c60c68;
}

.emp-search-option-tab {
  height: 32px;
  width: 230px;
  border-radius: 8.91px;
  background-color: rgba(118, 118, 128, 0.12);
  margin-right: 10px !important;
  padding-right: 8px;
  position: relative;
}
.emp-search-option-tab .emp-search-input {
  width: 200px;
  margin-left: 10px;
}
.emp-search-option-tab .emp-search-input .MuiInputBase-root {
  height: 41px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #cacaca !important;
}
.emp-search-option-tab .emp-search-input .MuiInputBase-root::before, .emp-search-option-tab .emp-search-input .MuiInputBase-root::after {
  border-bottom: unset;
}
.emp-search-option-tab .emp-search-input .MuiInputBase-input {
  padding: 13px 11px;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  color: #171a33;
}
.emp-search-option-tab .emp-search-button {
  font-size: small;
  background-color: #ffffff;
}
.emp-search-option-tab .emp-search-button:focus {
  background-color: rgba(118, 118, 128, 0.12);
}
.emp-search-option-tab .no-suggestions {
  color: #999;
  padding: 0.5rem;
  position: absolute;
  width: calc(210px + 1rem);
  top: 25px;
  left: 5px;
}
.emp-search-option-tab .suggestions {
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #999;
  list-style: none;
  margin-top: 0px;
  max-height: 143px;
  overflow-y: auto;
  padding-left: 5px;
  top: 32px;
  left: 5px;
  width: calc(210px + 1rem);
  position: absolute;
}
.emp-search-option-tab .suggestions li {
  padding: 0px;
}
.emp-search-option-tab .suggestion-active,
.emp-search-option-tab .suggestions li:hover {
  background-color: rgba(118, 118, 128, 0.12);
  color: #000000;
  cursor: pointer;
  order: 4;
}
.emp-search-option-tab .suggestions li:not(:last-of-type) {
  border-bottom: 1px solid #999;
}

.view-option-tab {
  height: 32px;
  width: 215px;
  border-radius: 8.91px;
  background-color: rgba(118, 118, 128, 0.12);
  margin-right: 17px !important;
}
.view-option-tab .tab-btn {
  width: 50%;
  height: 29px;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  color: #000000;
}
.view-option-tab .tab-btn.active {
  border: 0.5px solid rgba(0, 0, 0, 0.04);
  border-radius: 6.93px;
  background-color: #ffffff;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.12), 0 3px 1px 0 rgba(0, 0, 0, 0.04);
  font-family: TwCenMTStd-SemiBold !important;
}

.waiticon-modal {
  position: absolute;
  z-index: 1;
  padding-top: 150px;
  left: 300px;
}
.waiticon-modal:focus-visible {
  outline: none;
}

.dash-modal {
  position: absolute;
}
.dash-modal:focus-visible {
  outline: none;
}
.dash-modal .c-title {
  color: #171a33 !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  margin-top: 22px;
}
.dash-modal .dwdBtn {
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px !important;
}

.dash-drawer .MuiPaper-root {
  width: 438px !important;
  background-color: #ffffff;
  box-shadow: -5px 0 10px 0 rgba(0, 0, 0, 0.06) !important;
  padding: 24px 16px 16px 16px;
}
.dash-drawer .MuiPaper-root .citem {
  min-height: 102px;
  border-radius: 5px;
  background-color: #eff5f5;
  padding: 20px 20px 10px 20px;
  margin-bottom: 10px;
}
.dash-drawer .MuiPaper-root .citem .fnum {
  color: #171a33;
  font-size: 25px;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 0;
  line-height: 23px;
}
.dash-drawer .MuiPaper-root .citem .snum {
  color: #979598;
  font-size: 25px;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 0;
  line-height: 23px;
  margin-left: 8px;
}
.dash-drawer .MuiPaper-root .citem .det-info {
  color: #171a33;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 14px;
}
.dash-drawer .MuiPaper-root .citem .vmore {
  color: #344A5C;
  font-size: 12px;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 0;
  line-height: 11px;
  -webkit-text-decoration: underline solid #344A5C;
          text-decoration: underline solid #344A5C;
  cursor: pointer;
  margin-top: 6px;
}
.dash-drawer .MuiPaper-root .dtitle {
  color: #241a2e;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 21px;
}
.dash-drawer .MuiPaper-root .dclose {
  color: #241a2e;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 13px;
  cursor: pointer;
  -webkit-text-decoration: underline solid #241a2e;
          text-decoration: underline solid #241a2e;
}

.username_detailbox {
  text-align: left;
  width: 900px !important;
  display: flex;
}
.username_detailbox .nametext {
  margin-left: 20px;
  font-weight: bold;
  font-size: large;
  color: #344A5C;
}
.username_detailbox .viewdetails {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  align-self: flex-end;
}

.report-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow: auto;
}
.report-modal:focus-visible {
  outline: none;
}
.report-modal .modal-h-pad {
  padding: 16px 20px 30px 38px;
}
.report-modal .close-icon {
  border-radius: 30px;
  cursor: pointer;
}
.report-modal .modal-title {
  color: #344A5C !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  text-transform: unset;
}
.report-modal .down-box {
  height: 40px;
  width: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
}

.report-box {
  min-height: 440px;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}
.report-box .report-head {
  min-height: 120px;
  background-color: #344A5C;
  border-bottom: 6px solid #c3d34f;
  padding: 25px;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px !important;
  letter-spacing: 2px !important;
  line-height: 22px !important;
  text-align: center;
  text-transform: uppercase;
}
.report-box .report-body {
  padding: 20px 46px;
}
.report-box .report-body .rb-detail {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 22px !important;
  margin-bottom: 16px;
  -webkit-text-decoration: underline solid #171a33;
          text-decoration: underline solid #171a33;
  cursor: pointer;
}
.report-box .report-body .rb-detail-disabled {
  text-decoration-color: #a49c9c !important;
  cursor: unset !important;
  color: #a49c9c !important;
}
.report-box .report-body .rb-detail:last-child {
  margin-bottom: unset !important;
}

.report-table {
  height: 77vh !important;
  overflow: scroll !important;
}
.report-table thead .arrow-box {
  position: relative;
  margin-left: 3px;
  height: 10px;
  width: 7px;
}
.report-table thead .arrow-box .down {
  position: absolute;
  bottom: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.report-table thead .arrow-box .up {
  position: absolute;
  position: absolute;
  top: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.report-table thead th:first-child {
  padding-left: 20px;
}
.report-table thead th {
  padding: 10px 10px 7px 10px;
  background: #f8f8fa;
  border-bottom: unset;
}
.report-table thead th,
.report-table thead .th-title {
  color: #000000;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 14px !important;
  letter-spacing: 0;
  line-height: 11px;
}
.report-table tbody tr:nth-child(odd) {
  background: #e8e8e8 !important;
}
.report-table tbody tr:nth-child(even) {
  background: #ffffff !important;
}
.report-table tbody td:first-child {
  padding-left: 20px;
}
.report-table tbody td {
  padding: 5px 10px;
  color: #171a33 !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px;
  transition: 0.5s;
  min-height: 24px;
  border-bottom: unset;
}
.report-table tbody td .btn-over {
  display: none;
  transition: 0.5s;
}
.report-table tbody td button {
  padding: unset !important;
}
.report-table tbody td button svg {
  fill: #171a33 !important;
}
.report-table tbody tr {
  transition: 0.5s;
  background: #f8f8fa;
}
.report-table tbody tr .last-td {
  position: fixed;
  right: 0;
  border-bottom: unset !important;
}
.report-table tbody tr:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.report-table tbody tr:hover .btn-over {
  display: flex !important;
}
.report-table tbody .company-name {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 14px !important;
  letter-spacing: 0;
  line-height: 14px;
  max-width: 280px;
}

.ld-table thead .arrow-box {
  position: relative;
  margin-left: 3px;
  height: 10px;
  width: 7px;
}
.ld-table thead .arrow-box .down {
  position: absolute;
  bottom: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.ld-table thead .arrow-box .up {
  position: absolute;
  position: absolute;
  top: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.ld-table thead th:first-child {
  padding-left: 20px;
}
.ld-table thead th {
  padding: 10px 10px 7px 10px;
  background: #f8f8fa;
  border-bottom: unset;
}
.ld-table thead th,
.ld-table thead .th-title {
  color: #979598;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 11px;
}
.ld-table tbody tr:nth-child(even) {
  background: #f8f8fa !important;
}
.ld-table tbody tr:nth-child(odd) {
  background: #ffffff !important;
}
.ld-table tbody td:first-child {
  padding-left: 20px;
}
.ld-table tbody td {
  padding: 11.5px 10px;
  color: #171a33 !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  transition: 0.5s;
  height: 40px;
  border-bottom: unset;
}
.ld-table tbody td .btn-over {
  display: none;
  transition: 0.5s;
}
.ld-table tbody td button {
  padding: unset !important;
}
.ld-table tbody td button svg {
  fill: #171a33 !important;
}
.ld-table tbody tr {
  transition: 0.5s;
  background: #f8f8fa;
}
.ld-table tbody tr .last-td {
  position: fixed;
  right: 0;
  border-bottom: unset !important;
}
.ld-table tbody tr:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.ld-table tbody tr:hover .btn-over {
  display: flex !important;
}
.ld-table tbody .company-name {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  max-width: 280px;
}

.companie-table .pl-62 {
  padding-left: 52px !important;
}
.companie-table thead .arrow-box {
  position: relative;
  margin-left: 3px;
  height: 10px;
  width: 7px;
}
.companie-table thead .arrow-box .down {
  position: absolute;
  bottom: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.companie-table thead .arrow-box .up {
  position: absolute;
  position: absolute;
  top: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.companie-table thead th:first-child {
  padding-left: 20px;
}
.companie-table thead th {
  padding: 10px 10px 7px 10px;
  background: #f8f8fa;
}
.companie-table thead th,
.companie-table thead .th-title {
  color: #979598;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 11px;
}
.companie-table tbody .custom-field .custom-input {
  width: 400px;
}
.companie-table tbody .custom-field .custom-input .MuiInputBase-root {
  height: 41px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #cacaca !important;
}
.companie-table tbody .custom-field .custom-input .MuiInputBase-root::before, .companie-table tbody .custom-field .custom-input .MuiInputBase-root::after {
  border-bottom: unset;
}
.companie-table tbody .custom-field .custom-input .MuiInputBase-input {
  padding: 13px 11px;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  color: #171a33;
}
.companie-table tbody .d-avtaor {
  height: 32px;
  width: 32px;
  background-color: #344A5C;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  margin-right: 10px;
}
.companie-table tbody .ivited-badge {
  height: 24px;
  width: 67px;
  border-radius: 17px;
  background-color: #344A5C;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 13px;
  text-align: center;
  padding: 6px 10px;
}
.companie-table tbody .decative-badge {
  height: 24px;
  width: 68px;
  border-radius: 17px;
  background-color: #a70d0d;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0;
  line-height: 13px;
  text-align: center;
  padding: 6px 10px;
}
.companie-table tbody .mr-6 {
  margin-right: 6.5px;
}
.companie-table tbody .edit-btn {
  height: 40px;
  min-width: 71px !important;
  border: 1px solid #979598 !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  color: #171a33;
  font-family: TwCenMTStd-Bold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: capitalize !important;
  text-align: center;
  padding-left: 16px !important;
  padding-right: 14px !important;
}
.companie-table tbody .add-btn {
  height: 40px;
  min-width: 70px !important;
  border: 1px solid #344A5C !important;
  border-radius: 8px !important;
  background-color: #344A5C !important;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: capitalize !important;
  text-align: center;
  padding-left: 16px !important;
  padding-right: 14px !important;
}
.companie-table tbody .active-badge {
  height: 24px;
  width: 62px;
  border-radius: 17px;
  background-color: #c3d34f;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 13px;
  text-align: center;
  padding: 6px 10px;
}
.companie-table tbody td:first-child {
  padding-left: 20px;
}
.companie-table tbody td {
  padding: 11.5px 10px;
  color: #171a33 !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  transition: 0.5s;
  height: 56px;
}
.companie-table tbody td .btn-over {
  display: none;
  transition: 0.5s;
}
.companie-table tbody td button {
  padding: unset !important;
}
.companie-table tbody td button svg {
  fill: #171a33 !important;
}
.companie-table tbody tr {
  transition: 0.5s;
  background: #f8f8fa;
}
.companie-table tbody tr .last-td {
  position: fixed;
  right: 0;
  border-bottom: unset !important;
}
.companie-table tbody tr:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.companie-table tbody tr:hover .btn-over {
  display: flex !important;
}
.companie-table tbody .company-name {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  max-width: 280px;
}

.employee-table .border-right {
  border-right: 1px solid #d8d8d8;
}
.employee-table .border-bottom {
  border-right: 1px solid #d8d8d8;
}
.employee-table .body-content .MuiGrid-item {
  border-right: 1px solid #d8d8d8;
}
.employee-table .arrow-box {
  position: relative;
  margin-left: 3px;
  height: 10px;
  width: 7px;
}
.employee-table .arrow-box .down {
  position: absolute;
  bottom: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.employee-table .arrow-box .up {
  position: absolute;
  position: absolute;
  top: -10px;
  fill: #d8d8d8;
  cursor: pointer;
}
.employee-table .h-69 {
  height: 69px;
  padding: 0 24px;
  background: #f8f8fa;
}
.employee-table th,
.employee-table .th-title {
  color: #171a33;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 22px;
}
.employee-table .d-avtaor {
  height: 32px;
  width: 32px;
  background-color: #344A5C;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
}
.employee-table .mr-6 {
  margin-right: 6.5px;
}
.employee-table .edit-btn {
  height: 40px;
  min-width: 71px !important;
  border: 1px solid #979598 !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  color: #171a33;
  font-family: TwCenMTStd-Bold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: capitalize !important;
  text-align: center;
  padding-left: 16px !important;
  padding-right: 14px !important;
}
.employee-table .add-btn {
  height: 40px;
  min-width: 70px !important;
  border: 1px solid #344A5C !important;
  border-radius: 8px !important;
  background-color: #344A5C !important;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: capitalize !important;
  text-align: center;
  padding-left: 16px !important;
  padding-right: 14px !important;
}
.employee-table td {
  padding: 0px;
  color: #171a33 !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  transition: 0.5s;
  min-height: 60px;
  border-right: 1px solid #d8d8d8;
}
.employee-table .normal-box {
  min-height: 60px;
  padding: 11px 15px;
  background-color: #ffffff;
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #d8d8d8;
}
.employee-table .normal-box.red-bg {
  background-color: #ffdddd !important;
}
.employee-table .normal-box.blue-bg {
  background-color: #e6efff !important;
}
.employee-table .normal-box.green-bg {
  background-color: #edffee !important;
}
.employee-table .normal-box .redbar {
  width: 5px;
  background-color: #a70d0d;
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0px;
}
.employee-table .normal-box .bluebar {
  width: 5px;
  background-color: #344A5C;
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0px;
}
.employee-table .normal-box .greenbar {
  width: 5px;
  background-color: #c3d34f;
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0px;
}
.employee-table .normal-box .count {
  font-size: 14px;
  font-family: TwCenMTStd-SemiBold !important;
  color: #979598;
  margin-right: 13px !important;
}
.employee-table .normal-box .ename {
  font-size: 15px;
  font-family: TwCenMTStd-Bold !important;
  color: #171a33;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 6vw;
  cursor: pointer;
}
.employee-table .normal-box .edep {
  font-size: 12px;
  color: #979598;
}
.employee-table .normal-box .eval {
  font-size: 20px;
  font-family: TwCenMTStd-Bold !important;
  color: #171a33;
}
.employee-table td:last-child {
  border-right: unset !important;
}
.employee-table tr {
  transition: 0.5s;
  background: #f8f8fa;
}
.employee-table tr:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.employee-table .company-name {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  max-width: 280px;
}

.text-right {
  text-align: right;
}

.sidebar-footer,
.admin-sidebar-footer {
  width: 100%;
}
.sidebar-footer .MuiButtonBase-root,
.admin-sidebar-footer .MuiButtonBase-root {
  margin: unset !important;
  border-radius: unset !important;
  min-height: 48px;
  padding-left: 18px !important;
  padding-right: 10px !important;
}
.sidebar-footer .MuiButtonBase-root .MuiListItemIcon-root,
.admin-sidebar-footer .MuiButtonBase-root .MuiListItemIcon-root {
  margin-right: 9px;
}
.sidebar-footer .MuiButtonBase-root .MuiListItemText-primary,
.admin-sidebar-footer .MuiButtonBase-root .MuiListItemText-primary {
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  line-height: 16px !important;
  font-size: 18px !important;
}

.MuiToolbar-root {
  padding-left: 0px !important;
}

.inner-network {
  position: relative;
  height: auto;
}

.full-screen {
  height: 100%;
}

.pb-24 {
  padding-bottom: 24px;
}

.org-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 230px);
  overflow: auto;
  padding: 24px;
}
.org-container .org-parent .org-category-child {
  width: 120px;
  height: 70px;
  flex-wrap: nowrap;
}
.org-container .org-parent .org-category-child .org-category-box {
  height: 70px;
  width: 70px;
  background-color: #cccdd2;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 25px;
  letter-spacing: 0;
  line-height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.org-container .org-parent .org-category-child .org-category-box.child-active {
  background-color: rgba(198, 12, 104, 0.5);
}
.org-container .org-parent .org-category-child .org-category-box .more-child {
  width: 14px;
  height: 14px;
  background-color: #979598;
  border-radius: 50%;
  color: #ffffff;
  font-size: 10px;
  font-family: TwCenMTStd-Bold !important;
  position: absolute;
  cursor: pointer;
  right: -6px;
}
.org-container .org-parent .org-category-child .org-category-box .letter {
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 25px;
  letter-spacing: 0;
  line-height: 23px;
  text-transform: uppercase;
}
.org-container .org-parent .org-category-child .sub-child-box {
  position: absolute;
  right: 0px;
  top: 0px;
}
.org-container .org-parent .org-category-child .org-category-box-child {
  height: 60px;
  width: 60px;
  background-color: #cccdd2;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 22px;
  letter-spacing: 0;
  line-height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.org-container .org-parent .org-category-child .org-category-box-child.child-active {
  background-color: rgba(198, 12, 104, 0.5);
}
.org-container .org-parent .org-category-child .org-category-box-child .more-child {
  width: 14px;
  height: 14px;
  background-color: #979598;
  border-radius: 50%;
  color: #ffffff;
  font-size: 10px;
  font-family: TwCenMTStd-Bold !important;
  position: absolute;
  cursor: pointer;
  right: -6px;
}
.org-container .org-parent .org-category-child .org-category-box-child .letter {
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 22px;
  letter-spacing: 0;
  line-height: 23px;
  text-transform: uppercase;
}
.org-container .org-parent .org-category-child .org-category-box-subchild {
  height: 50px;
  width: 50px;
  background-color: #cccdd2;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.org-container .org-parent .org-category-child .org-category-box-subchild.child-active {
  background-color: rgba(198, 12, 104, 0.5);
}
.org-container .org-parent .org-category-child .org-category-box-subchild .more-child {
  width: 14px;
  height: 14px;
  background-color: #979598;
  border-radius: 50%;
  color: #ffffff;
  font-size: 10px;
  font-family: TwCenMTStd-Bold !important;
  position: absolute;
  cursor: pointer;
  right: -6px;
}
.org-container .org-parent .org-category-child .org-category-box-subchild .letter {
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 23px;
  text-transform: uppercase;
}
.org-container .org-parent .org-category-child .line {
  height: 1px;
  background-color: #171a33;
  flex: 1 1;
  position: relative;
}
.org-container .org-parent .org-category-child .line .circle {
  position: absolute;
  right: 0;
  width: 10px;
  background-color: #171a33;
  height: 10px;
  border-radius: 50%;
  top: -5px;
}
.org-container .org-parent .one {
  position: absolute;
  transform: rotate(-70deg);
  top: 5px;
  left: 130px;
  width: 146px !important;
}
.org-container .org-parent .one .letter,
.org-container .org-parent .one .more-child {
  transform: rotate(70deg);
}
.org-container .org-parent .one .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .one .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .one .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .one .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .one .sub-last-child-main.last-two .letter,
.org-container .org-parent .one .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .one .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .one .sub-last-child-main.last-three .letter,
.org-container .org-parent .one .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .one .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .one .sub-last-child-main.last-four .letter,
.org-container .org-parent .one .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .one .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .one .sub-last-child-main.last-five .letter,
.org-container .org-parent .one .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .two {
  position: absolute;
  transform: rotate(-25deg);
  top: 65px;
  left: 188px;
  width: 153px !important;
}
.org-container .org-parent .two .letter,
.org-container .org-parent .two .more-child {
  transform: rotate(25deg);
}
.org-container .org-parent .two .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .two .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .two .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .two .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .two .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .two .sub-last-child-main.last-two .letter,
.org-container .org-parent .two .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .two .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .two .sub-last-child-main.last-three .letter,
.org-container .org-parent .two .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .two .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .two .sub-last-child-main.last-four .letter,
.org-container .org-parent .two .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .two .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .two .sub-last-child-main.last-five .letter,
.org-container .org-parent .two .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .three {
  position: absolute;
  transform: rotate(14deg);
  top: 147px;
  left: 195px;
  width: 146px !important;
}
.org-container .org-parent .three .letter,
.org-container .org-parent .three .more-child {
  transform: rotate(-14deg);
}
.org-container .org-parent .three .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .three .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .three .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .three .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .three .sub-last-child-main.last-two .letter,
.org-container .org-parent .three .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .three .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .three .sub-last-child-main.last-three .letter,
.org-container .org-parent .three .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .three .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .three .sub-last-child-main.last-four .letter,
.org-container .org-parent .three .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .three .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .three .sub-last-child-main.last-five .letter,
.org-container .org-parent .three .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .four {
  position: absolute;
  transform: rotate(69deg);
  top: 229px;
  left: 120px;
  width: 146px !important;
}
.org-container .org-parent .four .letter,
.org-container .org-parent .four .more-child {
  transform: rotate(-70deg);
}
.org-container .org-parent .four .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .four .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .four .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .four .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .four .sub-last-child-main.last-two .letter,
.org-container .org-parent .four .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .four .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .four .sub-last-child-main.last-three .letter,
.org-container .org-parent .four .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .four .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .four .sub-last-child-main.last-four .letter,
.org-container .org-parent .four .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .four .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .four .sub-last-child-main.last-five .letter,
.org-container .org-parent .four .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .five {
  position: absolute;
  transform: rotate(-236deg);
  top: 218px;
  left: 15px;
  width: 146px !important;
}
.org-container .org-parent .five .letter,
.org-container .org-parent .five .more-child {
  transform: rotate(236deg);
}
.org-container .org-parent .five .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .five .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .five .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .five .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .five .sub-last-child-main.last-two .letter,
.org-container .org-parent .five .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .five .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .five .sub-last-child-main.last-three .letter,
.org-container .org-parent .five .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .five .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .five .sub-last-child-main.last-four .letter,
.org-container .org-parent .five .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .five .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .five .sub-last-child-main.last-five .letter,
.org-container .org-parent .five .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .six {
  position: absolute;
  transform: rotate(-200deg);
  top: 152px;
  left: -40px;
  width: 146px !important;
}
.org-container .org-parent .six .letter,
.org-container .org-parent .six .more-child {
  transform: rotate(200deg);
}
.org-container .org-parent .six .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .six .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .six .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .six .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .six .sub-last-child-main.last-two .letter,
.org-container .org-parent .six .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .six .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .six .sub-last-child-main.last-three .letter,
.org-container .org-parent .six .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .six .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .six .sub-last-child-main.last-four .letter,
.org-container .org-parent .six .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .six .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .six .sub-last-child-main.last-five .letter,
.org-container .org-parent .six .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .seven {
  position: absolute;
  transform: rotate(-161deg);
  top: 77px;
  left: -41px;
  width: 146px !important;
}
.org-container .org-parent .seven .letter,
.org-container .org-parent .seven .more-child {
  transform: rotate(161deg);
}
.org-container .org-parent .seven .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .seven .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .seven .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-two .letter,
.org-container .org-parent .seven .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-three .letter,
.org-container .org-parent .seven .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-four .letter,
.org-container .org-parent .seven .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .seven .sub-last-child-main.last-five .letter,
.org-container .org-parent .seven .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .eight {
  position: absolute;
  transform: rotate(-120deg);
  top: 6px;
  left: 21px;
  width: 146px !important;
}
.org-container .org-parent .eight .letter,
.org-container .org-parent .eight .more-child {
  transform: rotate(120deg);
}
.org-container .org-parent .eight .sub-child-main {
  position: absolute;
  right: -126px;
  transform: rotate(0deg);
}
.org-container .org-parent .eight .sub-last-child-main {
  position: absolute;
  left: 132px;
}
.org-container .org-parent .eight .sub-last-child-main.last-one {
  transform: rotate(0deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-two {
  top: -35px;
  left: 119px !important;
  transform: rotate(-35deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-two .letter,
.org-container .org-parent .eight .sub-last-child-main.last-two .more-child {
  transform: rotate(-126deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-three {
  top: -57px;
  left: 90px !important;
  transform: rotate(-70deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-three .letter,
.org-container .org-parent .eight .sub-last-child-main.last-three .more-child {
  transform: rotate(-90deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-four {
  top: 39px;
  left: 119px !important;
  transform: rotate(39deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-four .letter,
.org-container .org-parent .eight .sub-last-child-main.last-four .more-child {
  transform: rotate(160deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-five {
  top: -60px;
  left: 52px !important;
  transform: rotate(-106deg);
}
.org-container .org-parent .eight .sub-last-child-main.last-five .letter,
.org-container .org-parent .eight .sub-last-child-main.last-five .more-child {
  transform: rotate(-55deg);
}
.org-container .org-parent .org-main {
  height: 100px;
  width: 100px;
  background-color: #cccdd2;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 25px;
  letter-spacing: 0;
  line-height: 23px;
  text-transform: uppercase;
  position: relative;
  left: 100px;
  top: 100px;
}

.MuiList-root .sideBarActive {
  background-color: rgba(195, 211, 79, 0.15) !important;
}
.MuiList-root .sideBarActive::before {
  content: "";
  position: absolute;
  left: 0;
  min-height: 48px;
  width: 8px;
  background-color: #c3d34f;
}

.sidebarLink {
  text-decoration: none !important;
  color: unset !important;
}
.sidebarLink .MuiButtonBase-root {
  margin: unset !important;
  border-radius: unset !important;
  min-height: 48px;
  padding-left: 18px !important;
  padding-right: 10px !important;
}
.sidebarLink .MuiButtonBase-root .MuiListItemIcon-root {
  margin-right: 9px;
}
.sidebarLink .MuiButtonBase-root .MuiListItemText-primary {
  color: #ffffff;
  font-family: TwCenMTStd-SemiBold !important;
  line-height: 16px !important;
  font-size: 18px !important;
}

.contant-bgcolor {
  background: #f8f8fa;
}

.linkHide {
  text-decoration: none !important;
  color: unset !important;
}

.hr-text {
  color: #000000 !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 11px;
}
.hr-text .s-dot {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.d-flex-a {
  display: flex;
  align-items: center;
}

.flex-column {
  flex-direction: column;
}

.d-flex-j {
  display: flex;
  justify-content: center;
}

.d-felx-je {
  display: flex;
  justify-content: space-evenly;
}

.d-flex {
  display: flex;
}

.flex-sb {
  justify-content: space-between;
}

.flex-end {
  justify-content: flex-end;
}

.flex-1 {
  flex: 1 1;
}

.mb-7 {
  margin-bottom: 7px !important;
}

.mb-8 {
  margin-bottom: 8px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mt-25 {
  margin-top: 25px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mb-12 {
  margin-bottom: 12px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.pt-15 {
  padding-top: 15px;
}

.select-arrow {
  fill: #171a33;
}

.d-flex-ja {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-banner {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-banner .login-box {
  min-height: 344px;
  width: 414px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.22);
  padding: 0px 30px 21px 30px;
}
.login-banner .info-text {
  color: #171a33;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 15px;
}
.login-banner .otp-text {
  color: #171a33;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
}
.login-banner .link-text {
  color: #979598;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 14px;
  margin-top: 14px;
}
.login-banner .back-btn {
  color: #344A5C;
  -webkit-text-decoration: underline solid #344A5C;
          text-decoration: underline solid #344A5C;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 16px;
  letter-spacing: 0;
  text-transform: capitalize !important;
  line-height: 14px;
  margin-top: 36px;
  margin-bottom: 8px;
}
.login-banner .back-btn:hover {
  -webkit-text-decoration: underline solid #344A5C;
          text-decoration: underline solid #344A5C;
}
.login-banner .logo-text {
  font-size: 40px;
  margin-top: 50px;
  margin-bottom: 43px;
  color: #344A5C;
  text-align: center;
  justify-content: center;
  font-family: TwCenMTStd-Bold !important;
}
.login-banner .logo-text p {
  font-size: 40px;
  color: #c3d34f;
  font-family: TwCenMTStd-Bold !important;
}
.login-banner .logo-text p::first-letter {
  letter-spacing: -10px;
}
.login-banner .forgot-pass-description {
  font-size: 15px !important;
  color: #979598 !important;
  font-family: TwCenMTStd-Regular !important;
  padding-bottom: 10px !important;
}
.login-banner .forgot-pass-heading {
  font-size: 18px !important;
  font-family: TwCenMTStd-Regular !important;
  color: #171a33 !important;
}
.login-banner .custom-field p {
  color: #171a33 !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 24px;
  font-family: TwCenMTStd-SemiMedium !important;
}
.login-banner .custom-field .forgot-password {
  color: #db2426 !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 24px;
  cursor: pointer !important;
  text-decoration: underline !important;
  font-family: TwCenMTStd-SemiMedium !important;
}
.login-banner .custom-field .MuiFormHelperText-root {
  color: #d32f2f !important;
}
.login-banner .custom-field .custom-input {
  width: 100%;
}
.login-banner .custom-field .custom-input .MuiInputBase-root {
  height: 43px;
  border-radius: 7px;
  background-color: #f8f8fa;
}
.login-banner .custom-field .custom-input .MuiInputBase-root::before, .login-banner .custom-field .custom-input .MuiInputBase-root::after {
  border-bottom: unset;
}
.login-banner .custom-field .custom-input .MuiInputBase-input {
  padding: 13px 11px;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  color: #171a33;
}
.login-banner .submit-btn {
  margin-top: 20px;
  height: 44px;
  width: 100%;
  border-radius: 4px;
  color: #ffffff;
  background-color: #c3d34f;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  letter-spacing: 1px !important;
}
.login-banner .submit-btn:hover {
  background-color: #c3d34f;
}
.login-banner .border-box {
  height: 1px;
  background-color: #e8e8e8;
  margin: 30px 0 23px 0;
}
.login-banner .copy-text {
  color: #171a33;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
}
.login-banner .back-to-login {
  color: #979598;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
}

.border-bottom {
  border-bottom: 1px solid #e8e8e8;
}

.drawer-close {
  height: 44px;
  width: 44px;
  border: 4px solid #ffffff;
  background-color: #eaeaef;
  border-radius: 50%;
  cursor: pointer;
  position: fixed;
  margin-left: -56px !important;
  margin-top: 30px !important;
}
.drawer-close svg {
  fill: #979598;
}

.px-17 {
  padding-left: 17px;
  padding-right: 17px;
}

.py-16 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.textarea-noresize {
  resize: none;
}

.header-tab {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 15px !important;
  letter-spacing: 1px !important;
  line-height: 14px !important;
  padding: 35px 12px 30px 12px;
  display: flex;
  align-items: center;
  min-width: 86px;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.header-tab.active::after {
  content: "";
  height: 5px;
  background-color: #c3d34f;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.p-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 24px !important;
  letter-spacing: 0px !important;
  line-height: 21px !important;
}

.profile-modal .MuiBox-root:focus-visible {
  border: none;
  outline: none;
}
.profile-modal .MuiBox-root .labels {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiMedium !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  margin-bottom: 20px !important;
}
.profile-modal .MuiBox-root .client-labels {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiMedium !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  margin-bottom: 5px !important;
}
.profile-modal .MuiBox-root .details {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  margin-bottom: 20px !important;
  margin-right: 25px;
}
.profile-modal .MuiBox-root .clientpop-details {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  margin-bottom: 5px !important;
  margin-right: 25px;
}
.profile-modal .MuiBox-root .close-text {
  color: #344A5C !important;
  -webkit-text-decoration: underline solid #344A5C;
          text-decoration: underline solid #344A5C;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  cursor: pointer;
}

.set-parent {
  min-height: calc(100vh - 80px);
}
.set-parent .set-child {
  min-height: 237px;
  margin-top: -80px !important;
  width: 500px;
  background-color: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
}
.set-parent .set-child .px-24 {
  padding: 0 24px;
}
.set-parent .set-child .sett-box {
  min-height: 63px;
  border-bottom: 1px solid #e8e8e8;
}
.set-parent .set-child .sett-box svg {
  cursor: pointer;
  fill: #171a33;
  font-size: 16px;
}

.n-btn {
  color: #171a33 !important;
  font-size: 14px !important;
  letter-spacing: 1px !important;
  line-height: 14px !important;
  font-family: TwCenMTStd-SemiBold !important;
  -webkit-text-decoration: underline solid #171a33 !important;
          text-decoration: underline solid #171a33 !important;
}

.save-btn {
  height: 48px;
  min-width: 124px !important;
  border-radius: 4px !important;
  background-color: #0061ff !important;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 15px !important;
  letter-spacing: 0.94px !important;
  line-height: 14px !important;
}

.cancel-btn {
  height: 48px;
  min-width: 124px !important;
  border-radius: 4px !important;
  background-color: #979598 !important;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 15px !important;
  letter-spacing: 0.94px !important;
  line-height: 14px !important;
}

.role-sidebox {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}
.role-sidebox .role-italic {
  color: #0061ff !important;
  font-family: TwCenMTStd-Italic !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 20px !important;
}
.role-sidebox .role-item {
  cursor: pointer !important;
  min-height: 64px;
  background-color: rgba(255, 255, 255, 0.13);
  color: #979598 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 16px !important;
  padding: 0 24px;
  display: flex;
  align-items: center;
}
.role-sidebox .role-item.role-acitive {
  background-color: rgba(0, 97, 255, 0.13) !important;
  color: #171a33 !important;
}
.role-sidebox .role-item .div {
  color: #979598 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 16px !important;
}

.role-contentbox {
  padding: 30px;
}
.role-contentbox .permission-box {
  min-height: 330px;
  border-radius: 10px !important;
  background-color: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  padding: 36px 48px;
}
.role-contentbox .permission-box .per-title {
  color: #171a33 !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  margin-bottom: 18px;
  padding-left: 10px;
}

.role-class-code-contentbox {
  padding: 30px;
  padding-top: 0px;
}
.role-class-code-contentbox .permission-box {
  min-height: 330px;
  border-radius: 10px !important;
  background-color: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
}
.role-class-code-contentbox .permission-box .per-title {
  color: #171a33 !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  padding: 20px 20px 20px 20px;
  border-bottom: 1px solid #e8e8e8;
}
.role-class-code-contentbox .permission-box .class-code-div {
  padding: 10px 20px;
  background-color: #f7f5f9;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
}
.role-class-code-contentbox .permission-box .class-code-div .class-code-name {
  color: #979598 !important;
  font-size: 18px !important;
  font-family: TwCenMTStd-Regular !important;
  letter-spacing: 0;
}
.role-class-code-contentbox .permission-box .class-code-div .class-code-count {
  color: #979598 !important;
  font-size: 12px !important;
  font-family: TwCenMTStd-SemiBold !important;
  letter-spacing: 0;
}
.role-class-code-contentbox .permission-box .active {
  border-left: 5px solid #0061ff;
  background-color: #ffffff;
}
.role-class-code-contentbox .permission-box .active .class-code-name {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
}
.role-class-code-contentbox .permission-box .active .class-code-count {
  color: #0061ff !important;
}
.role-class-code-contentbox .permission-box .input-field {
  width: 100% !important;
}
.role-class-code-contentbox .permission-box .input-field .MuiInput-underline {
  padding-bottom: 8px !important;
}
.role-class-code-contentbox .permission-box .input-field .MuiInput-underline::before {
  border-bottom: 1px solid #e8e8e8 !important;
}
.role-class-code-contentbox .permission-box .input-field .MuiInput-underline::after {
  border-bottom: 1px solid #e8e8e8 !important;
}
.role-class-code-contentbox .permission-box .class-code-list-box {
  margin-top: 15px !important;
}
.role-class-code-contentbox .permission-box .class-code-list-box .class-code-list-view {
  align-items: center !important;
  margin-top: 3px;
  padding: 3px 10px;
  border-radius: 4px;
  cursor: pointer !important;
}
.role-class-code-contentbox .permission-box .class-code-list-box .class-code-list-view .class-code-list-text {
  color: #171a33 !important;
  font-size: 18px !important;
  font-family: TwCenMTStd-Regular !important;
  letter-spacing: 0;
}
.role-class-code-contentbox .permission-box .class-code-list-box .list-view-active {
  background-color: #e0ecff;
}

.h-44 {
  min-height: 44px;
}
.h-44 p {
  color: #171a33 !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}

.normal-checkbox {
  height: 24px;
  width: 24px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background-color: #efefef;
}

.parent-checkbox {
  margin-left: unset !important;
}

.ml-40 {
  margin-left: 40px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.ml-20 {
  margin-left: 20px !important;
}

.ml-8 {
  margin-left: 8px !important;
}

.custom-checkbox .MuiCheckbox-root.Mui-checked {
  color: #0061ff !important;
}
.custom-checkbox span {
  color: #171a33 !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}

.h-161 {
  min-height: calc(100vh - 161px);
}

.modal-gmail {
  color: #171a33 !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  margin-top: 7px !important;
  word-break: break-all;
}

.modal-name {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
  word-break: break-all;
}

.add-photo {
  color: #344A5C !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 14px !important;
  letter-spacing: 0;
  line-height: 13px !important;
  -webkit-text-decoration: underline solid #344A5C;
          text-decoration: underline solid #344A5C;
  cursor: pointer;
  margin-top: 6px !important;
}

.text-center {
  text-align: center;
}

.flex-1 {
  flex: 1 1;
}

.pl-32 {
  padding-left: 32px !important;
}

.pt-10 {
  padding-top: 10px !important;
}

.pop-default {
  height: 50px;
  width: 50px;
  background-color: #344A5C;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px !important;
  border-radius: 50%;
  letter-spacing: 0;
  line-height: 22px;
}

.pop-default2 {
  height: 50px;
  width: 50px;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px !important;
  border-radius: 50%;
  letter-spacing: 0;
  line-height: 22px;
}

.profile-default {
  height: 100px;
  width: 100px;
  background-color: #344A5C;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px !important;
  border-radius: 50%;
  letter-spacing: 0;
  line-height: 22px;
}

.pl-8 {
  padding-left: 8px;
}

.mt-10 {
  margin-top: 10px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

.px-87 {
  padding-left: 87px;
  padding-right: 87px;
}

.warn-text {
  margin-top: 4px;
  color: #a70d0d !important;
  font-size: 12px !important;
  font-style: italic;
  letter-spacing: 0;
  line-height: 11px !important;
}

.warn-text-15 {
  margin-top: 30px !important;
  padding-left: 10px;
  color: #a70d0d !important;
  font-family: TwCenMTStd-Italic !important;
  font-size: 15px !important;
  font-style: italic;
  letter-spacing: 0;
  line-height: 11px !important;
}

.normal-text {
  color: #171a33 !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}

.cinput:checked {
  background-color: #c3d34f;
}

.custom-switch {
  height: 31px !important;
  width: 51px !important;
  padding: unset !important;
  border-radius: 30px !important;
  margin: 0 14px 0 8px;
}
.custom-switch .MuiSwitch-thumb {
  height: 28px !important;
  width: 28px !important;
  border: 0.5px solid rgba(0, 0, 0, 0.04) !important;
  background-color: #ffffff !important;
  margin-top: 1px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.15), 0 3px 1px 0 rgba(0, 0, 0, 0.06) !important;
}
.custom-switch .MuiSwitch-track {
  background-color: #979598;
}
.custom-switch .MuiButtonBase-root.Mui-checked + .MuiSwitch-track {
  background-color: #6fc889 !important;
  opacity: 1 !important;
}
.custom-switch .MuiSwitch-switchBase {
  padding: 0px !important;
}

.private-form .submit-btn {
  margin-top: 20px;
  height: 44px;
  width: 100%;
  border-radius: 4px;
  color: #ffffff;
  background-color: #c3d34f;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  letter-spacing: 1px !important;
}
.private-form .submit-btn:hover {
  background-color: #c3d34f;
}
.private-form .custom-field {
  margin-bottom: 8px;
}
.private-form .custom-field p {
  color: #171a33 !important;
  font-size: 12px !important;
  letter-spacing: 0;
  line-height: 24px;
  font-family: TwCenMTStd-SemiMedium !important;
}
.private-form .custom-field .MuiFormHelperText-root {
  color: #d32f2f !important;
}
.private-form .custom-field .custom-input {
  width: 100%;
}
.private-form .custom-field .custom-input .MuiOutlinedInput-notchedOutline {
  border: unset !important;
}
.private-form .custom-field .custom-input .MuiInputBase-root {
  height: 43px !important;
  border-radius: 7px !important;
  background-color: #f8f8fa;
}
.private-form .custom-field .custom-input .MuiInputBase-root::before, .private-form .custom-field .custom-input .MuiInputBase-root::after {
  border-bottom: unset;
}
.private-form .custom-field .custom-input .MuiInputBase-input {
  padding: 13px 11px;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  color: #171a33;
}
.private-form .custom-field .custom-input .MuiInputBase-input::placeholder {
  font-family: TwCenMTStd-Medium !important;
}
.private-form .custom-field .custom-big-input {
  width: 100%;
}
.private-form .custom-field .custom-big-input .MuiOutlinedInput-notchedOutline {
  border: unset !important;
}
.private-form .custom-field .custom-big-input .MuiInputBase-root {
  height: 48px !important;
  border-radius: 7px !important;
  background-color: #f8f8fa;
}
.private-form .custom-field .custom-big-input .MuiInputBase-root::before, .private-form .custom-field .custom-big-input .MuiInputBase-root::after {
  border-bottom: unset;
}
.private-form .custom-field .custom-big-input .MuiInputBase-input {
  padding: 13px 11px;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  color: #171a33;
}

.modal-yes-btn {
  height: 44px;
  width: 100%;
  border-radius: 4px;
  color: #ffffff !important;
  background-color: #a70d0d !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 1px !important;
}
.modal-yes-btn:hover {
  background-color: #a70d0d;
}
.modal-yes-btn:disabled {
  background-color: #870000;
}

.modal-yes1-btn {
  height: 44px;
  width: 100%;
  border-radius: 4px;
  color: #ffffff !important;
  background-color: #c3d34f !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 1px !important;
}
.modal-yes1-btn:hover {
  background-color: #c3d34f;
}
.modal-yes1-btn:disabled {
  background-color: #a3b32f;
}

.modal-no-btn {
  height: 44px;
  width: 100%;
  border-radius: 4px;
  color: #ffffff !important;
  background-color: #979598 !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 1px !important;
}
.modal-no-btn:hover {
  background-color: #979598;
}

.modal-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 18px !important;
  letter-spacing: 1.2px !important;
  line-height: 16px !important;
  text-transform: uppercase;
}

.modal-dis {
  color: #979598 !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 20px !important;
  margin-top: 6px !important;
  margin-bottom: 10px !important;
}

.closesvg {
  fill: #979598 !important;
  cursor: pointer;
}

.role-title {
  color: #241a2e !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 20px !important;
  letter-spacing: 0;
  line-height: 18px !important;
}

.tool-add-btn {
  height: 48px;
  width: 171px;
  border-radius: 4px;
  background-color: #c3d34f !important;
  font-size: 15px !important;
  letter-spacing: 0.94px !important;
  line-height: 14px;
  color: #ffffff !important;
  font-family: TwCenMTStd-Bold !important;
  margin-left: 25px !important;
  cursor: pointer;
}

.custom-toolbar {
  justify-content: space-between;
}
.custom-toolbar .page-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 22px !important;
  padding-left: 30px;
}
.custom-toolbar .backlabel {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 15px !important;
  letter-spacing: 0;
  line-height: 14px;
}
.custom-toolbar .backicon {
  fill: #171a33;
  font-size: 16px !important;
}
.custom-toolbar .vborder {
  height: 40px;
  width: 2px;
  background-color: #d8d8d8;
  margin: 0 20.5px;
}

.norecord {
  height: 400px;
}

.deactive-row:hover {
  background: #fff0f0 !important;
}

.active-row:hover {
  background: #edffee !important;
}

.inited-row:hover {
  background: #f2f2ff !important;
}

.pl-20 {
  padding-left: 20px;
}

.pointer {
  cursor: pointer;
}

.profile-item {
  padding: 4px 16px 12px 16px !important;
  border-bottom: 1px solid rgba(177, 180, 190, 0.22);
  margin-bottom: 20px;
}
.profile-item .MuiAvatar-root {
  background-color: #344A5C;
}
.profile-item .MuiListItemAvatar-root {
  min-width: 40px !important;
}
.profile-item .MuiListItemText-root {
  margin: unset !important;
  padding-left: 8px;
}
.profile-item .MuiListItemText-root span {
  color: #979598 !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-Medium !important;
  line-height: 14px !important;
  white-space: normal !important;
}
.profile-item .MuiListItemText-root p:first-child {
  color: #ffffff !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  line-height: 17px !important;
  margin-top: 3px;
  white-space: normal !important;
}
.profile-item .MuiListItemText-root p:last-child {
  color: #979598 !important;
  font-family: TwCenMTStd-Medium !important;
  font-size: 16px !important;
  line-height: 17px !important;
  margin-top: 5px !important;
  white-space: normal !important;
}

.headerlogo-text {
  font-size: 38px !important;
  color: #ffffff;
  text-align: center;
  justify-content: center;
  font-family: TwCenMTStd-Bold !important;
  padding-top: 5px;
}

.hr {
  font-size: 38px !important;
  color: #c3d34f;
  font-family: TwCenMTStd-Bold !important;
}
.hr::first-letter {
  letter-spacing: -10px;
}

.collapse-btn {
  height: 40px;
  width: 40px;
  background-color: #c3d34f !important;
  border-radius: 50% !important;
  z-index: 100;
}
.collapse-btn:hover {
  background-color: #c3d34f !important;
}

.piec .recharts-legend-wrapper {
  min-width: 15vw;
  max-width: 250px !important;
}

.turnoverChart .recharts-legend-wrapper {
  top: 10px !important;
  right: 0px !important;
  min-width: 15vw;
  max-width: 350px !important;
}

g:focus,
path:focus {
  outline: none !important;
}

.pieo .recharts-legend-wrapper {
  min-width: 20vw;
  max-width: 260px !important;
}
.pieo .ename {
  max-width: 10vw !important;
}
.pieo .hrchart .recharts-legend-wrapper {
  top: -45px !important;
  width: auto !important;
  right: 56px !important;
  min-width: unset !important;
}

@media (min-width: 1600px) {
  .hrchart .recharts-legend-wrapper {
    top: -45px !important;
    width: auto !important;
    right: 56px !important;
    min-width: unset !important;
  }
}
.dashboard-box {
  padding: 25px;
}
.dashboard-box .pie-box-summary {
  border-radius: 10px;
  padding: 18px 20px 15px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 0px;
  margin-bottom: 20px;
  margin-top: 10px;
  position: relative;
}
.dashboard-box .pie-box-summary .datagrid-container {
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  align-items: center;
  align-content: center;
}
.dashboard-box .pie-box-summary .datagrid-container .MuiDataGrid-root {
  --DataGrid-rowBorderColor: "#ffffff" !important ;
}
.dashboard-box .pie-box-summary .datagrid {
  display: flex;
  width: 100%;
  font-size: 17px !important;
  margin-bottom: 20px;
  border-radius: 10px;
}
.dashboard-box .pie-box-summary .datagrid-outside {
  width: 100%;
}
.dashboard-box .pie-box {
  min-height: 300px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 18px 20px 15px 20px;
  margin-bottom: 20px;
  position: relative;
}
.dashboard-box .pie-box .recharts-wrapper {
  width: 100% !important;
}
.dashboard-box .pie-box .recharts-legend-wrapper {
  left: unset !important;
  right: 0;
  top: 0;
}
.dashboard-box .pie-box .total-pie {
  color: #241a2e !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 40px !important;
  letter-spacing: 0;
  line-height: 38px !important;
}
.dashboard-box .pie-box .total-pie-extra-text {
  font-size: 30px !important;
}
.dashboard-box .pie-box .ave-pie {
  color: #171a33 !important;
  font-family: TwCenMTStd-Regular !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}
.dashboard-box .pie-box .legend-ul {
  list-style-type: none !important;
  padding-left: unset !important;
  margin-top: 28px;
}
.dashboard-box .pie-box .legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 13px;
  margin-left: 13px;
  margin-top: 2px;
}
.dashboard-box .pie-box .leg-info {
  color: #241a2e !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 17px !important;
  line-height: 23px !important;
  margin-bottom: 15px !important;
  padding-right: 12px;
}
.dashboard-box .pie-box .num-info {
  color: #241a2e !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 17px !important;
  line-height: 23px !important;
  margin-bottom: 15px !important;
  margin-top: -5px !important;
}
.dashboard-box .pie-box .app-info {
  color: #979598 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  line-height: 23px !important;
}
.dashboard-box .pie-box .app-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  line-height: 23px !important;
}
.dashboard-box .pie-box .vp-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 20px !important;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 25px !important;
}
.dashboard-box .pie-box .down-box {
  height: 40px;
  width: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  top: 18px;
  cursor: pointer;
}
.dashboard-box .pie-box .c-title {
  color: #171a33 !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  margin-top: 12px;
}
.dashboard-box .pie-box .info-im {
  cursor: pointer;
  margin-left: 5px;
}
.dashboard-box .pie-box .datagrid-container {
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  align-items: center;
  align-content: center;
}
.dashboard-box .pie-box .datagrid-container .MuiDataGrid-root {
  --DataGrid-rowBorderColor: "#ffffff" !important ;
}
.dashboard-box .pie-box .datagrid {
  display: flex;
  margin-top: 35px;
  width: 100%;
  font-size: 17px !important;
}
.dashboard-box .pie-box .datagrid-outside {
  width: 100%;
}

.super-app-theme-header {
  font-size: 17px !important;
  font-weight: bolder !important;
  height: 15px;
  color: #344A5C;
  background-color: #ffffff;
  border: none;
  align-items: center;
  align-content: center;
}
.super-app-theme-header .MuiDataGrid-columnHeaderTitle {
  font-weight: bold !important;
}

.super-app-theme-cell {
  font-size: 17px !important;
  height: 15px;
  color: #344A5C;
  background-color: #ffffff;
  border: none;
  align-items: center;
  align-content: center;
}

.employee-status-header {
  background-color: #36485A;
  color: #FFFFFF;
}

.needs-attention-text {
  border-radius: 10px;
  border: 1px solid #F8E4E6;
  background-color: #F8E4E6;
  color: #DF1717;
  width: 150px;
  text-align: center;
}

.on-the-move-text {
  border-radius: 10px;
  border: 1px solid #E0F3DF;
  background-color: #E0F3DF;
  color: #04C30A;
  width: 150px;
  text-align: center;
}

.good-standing-text {
  border-radius: 10px;
  border: 1px solid #ddddf5;
  background-color: #ddddf5;
  color: #344A5C;
  width: 150px;
  text-align: center;
}

.ov-box {
  padding: 30px 30px 30px 45px;
}
.ov-box .menu-box {
  min-height: 50px;
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  text-align: right;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 18px 20px 15px 20px;
  margin-bottom: 20px;
  position: relative;
}
.ov-box .menu-box .blank-space {
  float: left;
  width: 90%;
}
.ov-box .menu-box .containter-control {
  float: right;
}
.ov-box .category-status-container-normal-border {
  border: 1px solid #d6d6d6;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}
.ov-box .category-status-container-highlight-border {
  border: 1px solid #c22c2c;
  box-shadow: 0 4px 10px 0 #c22c2c;
}
.ov-box .category-status-container {
  border-radius: 10px;
  height: 144px;
  background-color: #ffffff;
  padding: 18px 16px;
  margin-bottom: 20px;
  position: relative;
}
.ov-box .category-status-container .down-box-plus {
  padding-left: 5px;
  height: 20px;
  width: 60px;
  border: 1px solid #E0F3DF;
  border-radius: 10px;
  background-color: #E0F3DF;
  color: #04C30A;
  font-size: 12px;
  font-weight: bold;
  text-align: right;
  margin-top: 3px;
}
.ov-box .category-status-container .img-icon-container {
  margin-bottom: 10px;
}
.ov-box .category-status-container .img-icon-container .img-icon {
  height: 14px;
  width: 14px;
  object-fit: fill;
  padding-bottom: 2px;
}
.ov-box .category-status-container .down-box-minus {
  padding-left: 5px;
  height: 20px;
  width: 60px;
  border: 1px solid #F8E4E6;
  border-radius: 10px;
  background-color: #F8E4E6;
  color: #DF1717;
  font-size: 12px;
  font-weight: bold;
  text-align: right;
  margin-top: 3px;
  float: right;
}
.ov-box .category-status-container .image-container {
  padding-top: 10px;
  text-align: right;
  vertical-align: middle;
  width: 100%;
}
.ov-box .category-status-container .image-container .image-graph {
  width: 110px;
  object-fit: fill;
}
.ov-box .category-status-container .c-title {
  color: #5E5E60 !important;
  font-size: 20px !important;
  letter-spacing: 0;
  line-height: 15px !important;
  margin-top: 10px;
}
.ov-box .category-status-container .total-title {
  font-size: 36px !important;
  font-weight: bold;
  padding-top: 5px;
}
.ov-box .category-status-container .footer-container {
  font-size: 10px;
  color: #838383 !important;
  margin-top: 10px;
  width: 100%;
}
.ov-box .pie-box {
  min-height: 300px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 18px 20px 15px 20px;
  margin-bottom: 20px;
  position: relative;
}
.ov-box .pie-box .recharts-wrapper {
  width: 100% !important;
}
.ov-box .pie-box .recharts-legend-wrapper {
  left: unset !important;
  right: 0;
  top: 0;
}
.ov-box .pie-box .total-pie {
  color: #241a2e !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 40px !important;
  letter-spacing: 0;
  line-height: 38px !important;
}
.ov-box .pie-box .total-pie-extra-text {
  font-size: 30px !important;
}
.ov-box .pie-box .ave-pie {
  color: #171a33 !important;
  font-family: TwCenMTStd-Regular !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}
.ov-box .pie-box .ave-pie1 {
  color: #171a33 !important;
  font-family: TwCenMTStd-Regular !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}
.ov-box .pie-box .legend-ul {
  list-style-type: none !important;
  padding-left: unset !important;
  margin-top: 28px;
}
.ov-box .pie-box .legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 13px;
  margin-left: 13px;
  margin-top: 2px;
}
.ov-box .pie-box .leg-info {
  color: #241a2e !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 17px !important;
  line-height: 23px !important;
  margin-bottom: 15px !important;
  padding-right: 12px;
}
.ov-box .pie-box .num-info {
  color: #241a2e !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 17px !important;
  line-height: 23px !important;
  margin-bottom: 15px !important;
  margin-top: -5px !important;
}
.ov-box .pie-box .app-info {
  color: #979598 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  line-height: 23px !important;
}
.ov-box .pie-box .app-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 18px !important;
  line-height: 23px !important;
}
.ov-box .pie-box .vp-title {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 20px !important;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 25px !important;
}
.ov-box .pie-box .down-box {
  height: 40px;
  width: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  top: 18px;
  cursor: pointer;
}
.ov-box .pie-box .c-title {
  color: #171a33 !important;
  font-size: 24px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  margin-top: 12px;
}
.ov-box .pie-box .R-title {
  color: #171a33 !important;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 21px !important;
}
.ov-box .pie-box .info-im {
  cursor: pointer;
  margin-left: 5px;
}

.smallside,
.normalside {
  overflow-x: hidden;
}
.smallside .MuiPaper-root,
.normalside .MuiPaper-root {
  z-index: 1000 !important;
}
.smallside .MuiDrawer-paper,
.normalside .MuiDrawer-paper {
  overflow-x: hidden;
}
.smallside .MuiDrawer-paper::-webkit-scrollbar,
.normalside .MuiDrawer-paper::-webkit-scrollbar {
  width: 0px;
}
.smallside .MuiDrawer-paper:hover,
.normalside .MuiDrawer-paper:hover {
  overflow-x: hidden;
}
.smallside .MuiDrawer-paper:hover::-webkit-scrollbar,
.normalside .MuiDrawer-paper:hover::-webkit-scrollbar {
  width: 5px;
  background-color: #c3d34f;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  scrollbar-width: thin;
  z-index: 100;
}
.smallside .MuiDrawer-paper:hover::-webkit-scrollbar-thumb,
.normalside .MuiDrawer-paper:hover::-webkit-scrollbar-thumb {
  background-color: #000000; /* Set the color of the thumb */
}
.smallside .MuiDrawer-paper:hover::-webkit-scrollbar-track,
.normalside .MuiDrawer-paper:hover::-webkit-scrollbar-track {
  border-radius: 5px;
}
.smallside .MuiDrawer-paper:hover::-webkit-scrollbar-track-piece,
.normalside .MuiDrawer-paper:hover::-webkit-scrollbar-track-piece {
  background: #e8e8e8;
  border-radius: 100px;
  cursor: pointer;
}
.smallside .MuiDrawer-paper:hover::-webkit-scrollbar-thumb,
.normalside .MuiDrawer-paper:hover::-webkit-scrollbar-thumb {
  background: #c3d34f;
  border-radius: 100px;
  cursor: pointer;
}

.draw-header {
  min-height: 80px !important;
  padding-top: 5px;
}

.smallside {
  width: 60px !important;
}
.smallside .profile-item .MuiListItemText-root {
  display: none;
}
.smallside .MuiDrawer-paper {
  width: 60px !important;
}
.smallside .profile-item {
  padding-left: 10px !important;
}
.smallside .sidebarLink .MuiListItemIcon-root {
  margin-right: unset !important;
}
.smallside .sidebarLink .MuiButtonBase-root {
  padding-left: 20px !important;
}

.set-diveder {
  height: 1px;
  background-color: rgba(177, 180, 190, 0.22);
  margin: 19px 0px !important;
  width: 100%;
}

.w-100 {
  width: 100%;
}

.extra {
  height: 80px;
  background-color: #171a33;
  width: 60px;
  text-align: center;
  padding: 12px 0px;
}

.adminextra {
  height: 80px;
  background-color: #263673;
  width: 60px;
  text-align: center;
  padding: 12px 0px;
}

.mb-18 {
  margin-bottom: 18px !important;
}

.mt-40 {
  margin-top: 40px;
}

.ld-box {
  margin-top: 30px !important;
}
.ld-box .ld-count-box {
  min-height: 144px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  padding: 18px 16px;
}
.ld-box .ld-count-box .ld-count {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 32px !important;
  letter-spacing: 0;
  line-height: 29px !important;
}
.ld-box .ld-count-box .ld-green {
  margin-top: 8px;
  color: #c3d34f !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}
.ld-box .ld-count-box .ld-green svg {
  fill: #c3d34f;
  margin-right: 7.5px;
}
.ld-box .ld-count-box .ld-red {
  margin-top: 8px;
  color: #a70d0d !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px !important;
}
.ld-box .ld-count-box .ld-red svg {
  fill: #a70d0d;
  margin-right: 7.5px;
}
.ld-box .ld-count-box .black-box {
  height: 40px;
  width: 40px;
  background-color: #171a33;
  border-radius: 50%;
}
.ld-box .ld-count-box .black-box .clock {
  fill: #ffffff;
}
.ld-box .ld-count-box .ld-c-title {
  color: #171a33 !important;
  font-size: 22px !important;
  letter-spacing: 0;
  line-height: 19px !important;
  margin-left: 9px !important;
}

.dash-count {
  color: #171a33 !important;
  font-family: TwCenMTStd-Bold !important;
  font-size: 32px !important;
  letter-spacing: 0;
  line-height: 29px !important;
}

.zero_per {
  fill: #c3d34f !important;
  font-size: 25px !important;
  margin-left: 19.5px !important;
}

.up-per2 {
  fill: #c60c0c !important;
  font-size: 25px !important;
  margin-left: 19.5px !important;
}

.down-per2 {
  transform: rotate(180deg);
  fill: #c3d34f !important;
  font-size: 25px !important;
  margin-left: 19.5px !important;
}

.per-txt2 {
  color: #979598;
  font-size: 10px;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 0;
  line-height: 12px;
  margin-left: 4px !important;
}

.dash-engament-box {
  min-height: 100px;
  border-radius: 10px;
  background-color: #F8F8FA;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  padding: 18px 16px;
}

@media (max-width: 768px) {
  .login-box {
    width: 75vw !important;
  }
  .custom-toolbar .page-title {
    font-size: 16px !important;
    padding-left: 12px !important;
  }
}
@media (min-width: 1280px) {
  .ld-box {
    width: 1100px;
  }
  .org-total-box {
    width: 1080px !important;
  }
}
.employee-drawer .MuiPaper-root {
  width: 580px !important;
  border-radius: 10px 0 0 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1) !important;
  padding-top: 30px !important;
}
.employee-drawer .MuiPaper-root .top-pad-box {
  padding: 15px 40px 15px 30px;
  border-bottom: 1px solid #e8e8e8;
}
.employee-drawer .MuiPaper-root .total-title {
  color: #979598;
  font-size: 18px;
  font-family: TwCenMTStd-Medium !important;
  letter-spacing: 0;
  line-height: 21px;
}
.employee-drawer .MuiPaper-root .no-box {
  min-height: 65px;
  justify-content: flex-end !important;
}
.employee-drawer .MuiPaper-root .total-num {
  color: #171a33;
  font-family: TwCenMTStd-Bold !important;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 36px;
}
.employee-drawer .MuiPaper-root .emp-line {
  color: #171a33;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 21px;
}
.employee-drawer .MuiPaper-root .line-sub {
  color: #979598;
  font-size: 15px;
  letter-spacing: 0;
  margin-top: 10px !important;
  line-height: 14px;
}
.employee-drawer .MuiPaper-root .linechart-emp {
  margin-top: 14px !important;
}
.employee-drawer .MuiPaper-root .default-pic {
  height: 60px;
  width: 60px;
  background-color: #344A5C;
  border-radius: 50%;
  color: #ffffff;
  font-family: TwCenMTStd-Bold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 14px;
  margin-right: 11px;
}
.employee-drawer .MuiPaper-root .emp-name {
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 23px;
}
.employee-drawer .MuiPaper-root .emp-dep {
  color: #979598;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 14px;
  margin-top: 9px !important;
}
.employee-drawer .MuiPaper-root .det-info {
  color: #171a33;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
}
.employee-drawer .MuiPaper-root .det-detail {
  color: #171a33;
  font-size: 16px;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 0;
  line-height: 20px;
  text-align: right;
}
.employee-drawer .MuiPaper-root .mt-14 {
  margin-top: 14px !important;
}
.employee-drawer .MuiPaper-root .ml-13 {
  margin-left: 13px !important;
}
.employee-drawer .MuiPaper-root .warn-pad-box {
  padding: 14px 30px 16px 30px;
}
.employee-drawer .MuiPaper-root .warn-pad-box .warn-info-box {
  height: 103px;
  border-radius: 10px;
  background-color: rgba(255, 169, 19, 0.2);
  box-shadow: 0 2px 2px 0 rgba(166, 107, 4, 0.2);
  padding: 20px 34px 17px 24px;
}
.employee-drawer .MuiPaper-root .warn-pad-box .warn-info-box .notes {
  color: #171a33;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}
.employee-drawer .MuiPaper-root .warn-pad-box .warn-info-box .info {
  color: #171a33;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 14px;
}
.employee-drawer .MuiPaper-root .warn-pad-box .warn-info-box .details {
  color: #171a33;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 14px;
  font-family: TwCenMTStd-Bold !important;
}
.employee-drawer .MuiPaper-root .eye-view {
  height: 40px;
  width: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
}

.org-view-more {
  color: #979598;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 21px !important;
  -webkit-text-decoration: underline solid #979598;
          text-decoration: underline solid #979598;
  font-family: TwCenMTStd-Medium !important;
  cursor: pointer;
}

.total-titles {
  color: #979598;
  font-size: 18px;
  font-family: TwCenMTStd-Medium !important;
  letter-spacing: 0;
  line-height: 21px;
}

.org-total-box {
  width: 100%;
  min-height: 112px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: 12px !important;
}
.org-total-box .ot-box {
  min-height: 112px;
  border-right: 1px solid #979797;
  padding: 0px 24px;
}
.org-total-box .no-box {
  min-height: 112px;
  padding: 0px 24px;
}
.org-total-box .up-per {
  fill: #c60c0c;
  font-size: 18px;
  margin-left: 2.5px !important;
}
.org-total-box .down-per {
  transform: rotate(180deg);
  fill: #c3d34f;
  font-size: 18px;
  margin-left: 2.5px !important;
}
.org-total-box .per-txt {
  color: #979598;
  font-size: 10px;
  font-family: TwCenMTStd-Bold !important;
  letter-spacing: 0;
  line-height: 12px;
  margin-left: 4px !important;
}
.org-total-box .total-title {
  color: #979598;
  font-size: 18px;
  font-family: TwCenMTStd-Medium !important;
  letter-spacing: 0;
  line-height: 21px;
}
.org-total-box .total-num {
  color: #171a33;
  font-family: TwCenMTStd-Bold !important;
  font-size: 30px;
  letter-spacing: 0;
  line-height: 36px;
}

.en-selectbox-disabled__indicators {
  display: none !important;
}

.custom-tooltip {
  background: #ffffff !important;
  padding: 10px !important;
  border-radius: 5px !important;
  border: 0.3px solid black !important;
}
.custom-tooltip p {
  color: black;
  font-family: TwCenMTStd-SemiBold !important;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 20px !important;
  margin: 0px !important;
  padding: 0px !important;
  padding: 5px !important;
}
.custom-tooltip .qns-blue {
  color: #344A5C !important;
}
.custom-tooltip .qns-green {
  color: #c3d34f !important;
}
.custom-tooltip .view-green {
  color: #c3d34f;
}
.custom-tooltip .view-dep {
  color: #344A5C;
}
.custom-tooltip .view-org {
  color: #c60c68;
}
.custom-tooltip .view-you {
  color: #0da728;
}
.custom-tooltip .valountry-blue {
  color: #5251b7 !important;
}
.custom-tooltip .in-valountry-green {
  color: #c3d34f !important;
}
.custom-tooltip .last-valountry-blue {
  color: #172087 !important;
}
.custom-tooltip .last-in-valountry-green {
  color: #8f9f18 !important;
}
.custom-tooltip .last-valountry-black {
  color: #000000 !important;
}

.rmenu {
  z-index: 10000;
  position: absolute;
  background-color: #ffffff;
  box-shadow: 10px salmon;
  padding: 5px;
  display: block;
  margin: 0;
  list-style-type: none;
  list-style: none;
  cursor: pointer;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding-right: 10px;
  padding-left: 10px;
}

.portal-name {
  color: #979598 !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-Medium !important;
  line-height: 14px !important;
  white-space: normal !important;
  margin-top: -10px !important;
  margin-bottom: 10px !important;
  font-weight: bold !important;
  letter-spacing: 0.6px !important;
  color: white !important;
}

.impersonate-name {
  color: #ffffff !important;
  font-size: 16px !important;
  font-family: TwCenMTStd-SemiBold !important;
  line-height: 16px !important;
  white-space: normal !important;
}

.stop-btn {
  background-color: #ffffff !important;
  border-radius: 10px !important;
  padding: 0px 13px !important;
  cursor: pointer !important;
}

.stop-name {
  color: red !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-weight: bold !important;
  margin-top: 3px !important;
}

.stop-divider {
  margin: 0px 10px !important;
  height: 20px !important;
  width: 2px !important;
  background: #5c5c5c !important;
}

.tooltip-text {
  color: #ffffff !important;
  font-size: 15px !important;
  font-family: TwCenMTStd-SemiBold !important;
  font-weight: bold !important;
  line-height: 20px !important;
}

.forgot-password-blue {
  color: #344A5C !important;
  font-size: 15px !important;
  letter-spacing: 1px !important;
  line-height: 24px;
  cursor: pointer !important;
  text-decoration: underline !important;
  font-family: TwCenMTStd-SemiMedium !important;
  text-decoration: underline;
}

.rmenu1 {
  z-index: 1000;
  position: absolute;
  background-color: #ffffff;
  box-shadow: 10px salmon;
  display: block;
  margin: 0;
  list-style-type: none;
  list-style: none;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style/style.scss","webpack://./src/style/_variable.scss"],"names":[],"mappings":"AAEA;EACE,iCAAA;EACA,4FACE;AAFJ;AAMA;EACE,kCAAA;EACA,6FACE;AALJ;AASA;EACE,gCAAA;EACA,2FACE;AARJ;AAYA;EACE,oCAAA;EACA,2FACE;AAXJ;AAeA;EACE,gCAAA;EACA,2FACE;AAdJ;AAkBA;EACE,+BAAA;EACA,0FACE;AAjBJ;AAqBA;EACE,8BAAA;EACA,yFACE;AApBJ;AAwBA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;AAtBF;;AAwBA;;;;;;;;;;;;;EAaE,0CAAA;AArBF;;AAuBA;EACE,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uBAAA;AApBF;;AAsBA;EACE,6BAAA;EACA,wBAAA;AAnBF;;AAqBA;EACE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;EAlBF;AACF;AAoBA;EACE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;EAlBF;AACF;AAoBA;EACE,aAAA;AAlBF;;AAoBA;EACE,6BAAA;AAjBF;;AAmBA;EACE,0BAAA;EACA,eAAA;AAhBF;;AAkBA;EACE,mBAAA;AAfF;;AAiBA;EACE,kBAAA;AAdF;;AAgBA;EACE,6BAAA;AAbF;;AAeA;EACE,6BAAA;AAZF;;AAcA;EACE,yBCpHY;ADyGd;;AAcE;EACE,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;AAXJ;;AAeE;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,oCAAA;EACA,uDAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;AAZJ;AAcE;EACE,kBAAA;AAZJ;AAcE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAZJ;AAcE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAZJ;AAcE;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gDAAA;UAAA,wCAAA;EACA,eAAA;AAZJ;AAcE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAZJ;AAaI;EAoCE,kBAAA;AA9CN;AAWM;EACE,eAAA;EACA,WAAA;EACA,yBCzKM;ED0KN,8BAAA;EACA,YAAA;EACA,kBAAA;AATR;AAUQ;EACE,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,2CAAA;AARV;AAUQ;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;AARV;AASU;EACE,yBAAA;EACA,0BAAA;EACA,2CAAA;EACA,4BAAA;AAPZ;AASU;EACE,wBAAA;AAPZ;AAWM;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AATR;AAYM;EACE,WAAA;AAVR;AAWQ;EACE,wBAAA;AATV;AAWQ;EACE,uBAAA;EACA,6BAAA;EACA,yBAAA;AATV;AAUU;EAEE,oBAAA;AATZ;AAYQ;EACE,+BAAA;AAVV;AAYQ;EACE,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,cC9NI;ADoNd;AAkBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,yBCxOQ;ADwNZ;AAkBE;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAhBJ;;AAoBE;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,oCAAA;EACA,uDAAA;EACA,0BAAA;EACA,4BAAA;AAjBJ;AAmBE;EACE,kBAAA;AAjBJ;AAmBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,yBCvQQ;ADsPZ;AAmBE;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAjBJ;;AAoBA;EACE,4BAAA;EACA,kCAAA;AAjBF;;AAoBE;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;AAjBJ;AAmBE;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;AAjBJ;AAmBE;EACE,YAAA;EACA,WAAA;AAjBJ;AAkBI;EACE,yBC9SS;AD8Rf;AAkBI;EACE,yBC1SO;AD0Rb;AAkBI;EACE,yBCxSS;ADwRf;;AAoBA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,2CCtTgB;EDuThB,6BAAA;EACA,kBAAA;EACA,kBAAA;AAjBF;AAkBE;EACE,YAAA;EACA,iBAAA;AAhBJ;AAiBI;EACE,YAAA;EACA,kBAAA;EACA,yBCpUQ;EDqUR,oCAAA;AAfN;AAgBM;EAEE,oBAAA;AAfR;AAkBI;EACE,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,cC9UQ;AD8Td;AAmBE;EACE,gBAAA;EACA,yBCpVU;ADmUd;AAmBE;EACE,2CCnVc;ADkUlB;AAmBE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,SAAA;AAjBJ;AAmBE;EACE,0BAAA;EACA,2CAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAjBJ;AAmBE;EACE,YAAA;AAjBJ;AAmBE;;EAEE,2CClXc;EDmXd,cAAA;EACA,eAAA;EACA,QAAA;AAjBJ;AAmBE;EACE,6BAAA;AAjBJ;;AAoBA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,2CC/XgB;EDgYhB,6BAAA;AAjBF;AAkBE;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAiBI;EACE,uCAAA;EACA,qBAAA;EACA,yBAAA;EACA,4EACE;EAEF,2CAAA;AAjBN;;AAqBA;EACE,kBAAA;EACA,UAAA;EAIA,kBAAA;EACA,WAAA;AArBF;AAiBE;EACE,aAAA;AAfJ;;AAoBA;EACE,kBAAA;AAjBF;AAkBE;EACE,aAAA;AAhBJ;AAkBE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,oCAAA;EACA,6BAAA;AAjBJ;;AAqBE;EACE,uBAAA;EACA,yBAAA;EACA,wDAAA;EACA,4BAAA;AAlBJ;AAmBI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;AAjBN;AAkBM;EACE,cCjcM;EDkcN,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;AAhBR;AAkBM;EACE,cCtcK;EDucL,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAhBR;AAkBM;EACE,cChdM;EDidN,eAAA;EACA,iBAAA;EACA,iBAAA;AAhBR;AAkBM;EACE,cCldK;EDmdL,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,gDAAA;UAAA,wCAAA;EACA,eAAA;EACA,eAAA;AAhBR;AAmBI;EACE,cC3dM;ED4dN,eAAA;EACA,iBAAA;EACA,iBAAA;AAjBN;AAmBI;EACE,cCjeM;EDkeN,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gDAAA;UAAA,wCAAA;AAjBN;;AAqBA;EACE,gBAAA;EACA,uBAAA;EACA,aAAA;AAlBF;AAmBE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cCpfS;ADmeb;AAmBE;EACE,iBAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;AAjBJ;;AAoBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,cAAA;AAjBF;AAkBE;EACE,aAAA;AAhBJ;AAkBE;EACE,4BAAA;AAhBJ;AAkBE;EACE,mBAAA;EACA,eAAA;AAhBJ;AAkBE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;AAhBJ;AAkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAhBJ;;AAmBA;EACE,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;AAhBF;AAiBE;EACE,iBAAA;EACA,yBCxiBS;EDyiBT,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,yBAAA;AAfJ;AAiBE;EACE,kBAAA;AAfJ;AAgBI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gDAAA;UAAA,wCAAA;EACA,eAAA;AAdN;AAgBI;EAEE,yCAAA;EACA,wBAAA;EACA,yBAAA;AAfN;AAiBI;EACE,+BAAA;AAfN;;AAmBA;EACE,uBAAA;EACA,2BAAA;AAhBF;AAkBI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAhBN;AAiBM;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AAfR;AAiBM;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AAfR;AAkBI;EACE,kBAAA;AAhBN;AAkBI;EACE,2BAAA;EACA,mBAAA;EACA,oBAAA;AAhBN;AAkBI;;EAEE,cAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AAhBN;AAoBI;EACE,8BAAA;AAlBN;AAoBI;EACE,8BAAA;AAlBN;AAoBI;EACE,kBAAA;AAlBN;AAoBI;EACE,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAlBN;AAmBM;EACE,aAAA;EACA,gBAAA;AAjBR;AAmBM;EACE,yBAAA;AAjBR;AAkBQ;EACE,wBAAA;AAhBV;AAoBI;EACE,gBAAA;EACA,mBAAA;AAlBN;AAmBM;EACE,eAAA;EACA,QAAA;EACA,+BAAA;AAjBR;AAmBM;EACE,0CAAA;AAjBR;AAkBQ;EACE,wBAAA;AAhBV;AAoBI;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAlBN;;AAwBI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AArBN;AAsBM;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AApBR;AAsBM;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AApBR;AAuBI;EACE,kBAAA;AArBN;AAuBI;EACE,2BAAA;EACA,mBAAA;EACA,oBAAA;AArBN;AAuBI;;EAEE,cC1sBO;ED2sBP,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AArBN;AAyBI;EACE,8BAAA;AAvBN;AAyBI;EACE,8BAAA;AAvBN;AAyBI;EACE,kBAAA;AAvBN;AAyBI;EACE,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;AAvBN;AAwBM;EACE,aAAA;EACA,gBAAA;AAtBR;AAwBM;EACE,yBAAA;AAtBR;AAuBQ;EACE,wBAAA;AArBV;AAyBI;EACE,gBAAA;EACA,mBAAA;AAvBN;AAwBM;EACE,eAAA;EACA,QAAA;EACA,+BAAA;AAtBR;AAwBM;EACE,0CAAA;AAtBR;AAuBQ;EACE,wBAAA;AArBV;AAyBI;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAvBN;;AA4BE;EACE,6BAAA;AAzBJ;AA4BI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AA1BN;AA2BM;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AAzBR;AA2BM;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AAzBR;AA4BI;EACE,kBAAA;AA1BN;AA4BI;EACE,2BAAA;EACA,mBAAA;AA1BN;AA4BI;;EAEE,cCzyBO;ED0yBP,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AA1BN;AAgCM;EACE,YAAA;AA9BR;AA+BQ;EACE,YAAA;EACA,kBAAA;EACA,yBC3zBI;ED4zBJ,oCAAA;AA7BV;AA8BU;EAEE,oBAAA;AA7BZ;AAgCQ;EACE,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,cCr0BI;ADuyBd;AAkCI;EACE,YAAA;EACA,WAAA;EACA,yBCx0BO;EDy0BP,kBAAA;EACA,cC/0BQ;EDg1BR,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAhCN;AAkCI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBCr1BO;EDs1BP,cC31BQ;ED41BR,uCAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAhCN;AAkCI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,cCz2BQ;ED02BR,uCAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAhCN;AAkCI;EACE,mBAAA;AAhCN;AAkCI;EACE,YAAA;EACA,0BAAA;EACA,oCAAA;EACA,6BAAA;EACA,oCAAA;EACA,cC13BQ;ED23BR,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;AAhCN;AAkCI;EACE,YAAA;EACA,0BAAA;EACA,oCAAA;EACA,6BAAA;EACA,oCAAA;EACA,cC34BQ;ED44BR,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;AAhCN;AAkCI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBC35BS;ED45BT,cC15BQ;ED25BR,uCAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAhCN;AAkCI;EACE,kBAAA;AAhCN;AAkCI;EACE,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAhCN;AAiCM;EACE,aAAA;EACA,gBAAA;AA/BR;AAiCM;EACE,yBAAA;AA/BR;AAgCQ;EACE,wBAAA;AA9BV;AAkCI;EACE,gBAAA;EACA,mBAAA;AAhCN;AAiCM;EACE,eAAA;EACA,QAAA;EACA,+BAAA;AA/BR;AAiCM;EACE,0CAAA;AA/BR;AAgCQ;EACE,wBAAA;AA9BV;AAkCI;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAhCN;;AAqCE;EACE,+BAAA;AAlCJ;AAoCE;EACE,+BAAA;AAlCJ;AAqCI;EACE,+BAAA;AAnCN;AAsCE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AApCJ;AAqCI;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AAnCN;AAqCI;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AAnCN;AAsCE;EACE,YAAA;EACA,eAAA;EACA,mBAAA;AApCJ;AAsCE;;EAEE,cCv/BU;EDw/BV,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AApCJ;AAsCE;EACE,YAAA;EACA,WAAA;EACA,yBC5/BS;ED6/BT,kBAAA;EACA,cCngCU;EDogCV,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AApCJ;AAsCE;EACE,mBAAA;AApCJ;AAsCE;EACE,YAAA;EACA,0BAAA;EACA,oCAAA;EACA,6BAAA;EACA,oCAAA;EACA,cCjhCU;EDkhCV,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;AApCJ;AAsCE;EACE,YAAA;EACA,0BAAA;EACA,oCAAA;EACA,6BAAA;EACA,oCAAA;EACA,cCliCU;EDmiCV,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;AApCJ;AAsCE;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AApCJ;AAsCE;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AApCJ;AAqCI;EACE,oCAAA;AAnCN;AAqCI;EACE,oCAAA;AAnCN;AAqCI;EACE,oCAAA;AAnCN;AAqCI;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAnCN;AAqCI;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAnCN;AAqCI;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAnCN;AAqCI;EACE,eAAA;EACA,2CAAA;EACA,cChmCO;EDimCP,6BAAA;AAnCN;AAqCI;EACE,eAAA;EACA,uCAAA;EACA,cCxmCQ;EDymCR,iBAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AApCN;AAuCI;EACE,eAAA;EACA,cClnCO;AD6kCb;AAuCI;EACE,eAAA;EACA,uCAAA;EACA,cCznCQ;ADolCd;AAwCE;EACE,8BAAA;AAtCJ;AAwCE;EACE,gBAAA;EACA,mBAAA;AAtCJ;AAuCI;EACE,0CAAA;AArCN;AAwCE;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAtCJ;;AAyCA;EACE,iBAAA;AAtCF;;AAwCA;;EAEE,WAAA;AArCF;AAsCE;;EACE,wBAAA;EACA,+BAAA;EACA,gBAAA;EACA,6BAAA;EACA,8BAAA;AAnCJ;AAoCI;;EACE,iBAAA;AAjCN;AAmCI;;EACE,cChqCQ;EDiqCR,2CAAA;EACA,4BAAA;EACA,0BAAA;AAhCN;;AAoCA;EACE,4BAAA;AAjCF;;AAmCA;EACE,kBAAA;EACA,YAAA;AAhCF;;AAkCA;EACE,YAAA;AA/BF;;AAoCA;EACE,oBAAA;AAjCF;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;AAhCF;AAuCI;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AArCN;AAuCM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9sCM;ED+sCN,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAIA,kBAAA;AAxCR;AAqCQ;EACE,yCAAA;AAnCV;AAsCQ;EACE,WAAA;EACA,YAAA;EACA,yBC1tCG;ED2tCH,kBAAA;EACA,cC/tCI;EDguCJ,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AApCV;AAsCQ;EACE,cCvuCI;EDwuCJ,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AApCV;AAuCM;EAGE,kBAAA;EACA,UAAA;EACA,QAAA;AAvCR;AAyCM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC3vCM;ED4vCN,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAIA,kBAAA;AA1CR;AAuCQ;EACE,yCAAA;AArCV;AAwCQ;EACE,WAAA;EACA,YAAA;EACA,yBCvwCG;EDwwCH,kBAAA;EACA,cC5wCI;ED6wCJ,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAtCV;AAwCQ;EACE,cCpxCI;EDqxCJ,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAtCV;AAyCM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCjyCM;EDkyCN,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAIA,kBAAA;AA1CR;AAuCQ;EACE,yCAAA;AArCV;AAwCQ;EACE,WAAA;EACA,YAAA;EACA,yBC7yCG;ED8yCH,kBAAA;EACA,cClzCI;EDmzCJ,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAtCV;AAwCQ;EACE,cC1zCI;ED2zCJ,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAtCV;AAyCM;EACE,WAAA;EACA,yBCn0CM;EDo0CN,SAAA;EACA,kBAAA;AAvCR;AAwCQ;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,yBC10CI;ED20CJ,YAAA;EACA,kBAAA;EACA,SAAA;AAtCV;AA0CI;EACE,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,wBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,wBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,yBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,yBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,yBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,yBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,yBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,kBAAA;EACA,0BAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;AAxCN;AAyCM;;EAEE,yBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAvCR;AAyCM;EACE,kBAAA;EACA,WAAA;AAvCR;AAwCQ;EACE,uBAAA;AAtCV;AAwCQ;EACE,UAAA;EACA,sBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,0BAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,yBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,SAAA;EACA,sBAAA;EACA,wBAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AAwCQ;EACE,UAAA;EACA,qBAAA;EACA,0BAAA;AAtCV;AAuCU;;EAEE,yBAAA;AArCZ;AA0CI;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCpzDQ;EDqzDR,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAxCN;;AA6CE;EACE,qDAAA;AA1CJ;AA2CI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;EACA,yBC30DS;ADkyDf;;AAgDA;EACE,gCAAA;EACA,uBAAA;AA7CF;AA8CE;EACE,wBAAA;EACA,+BAAA;EACA,gBAAA;EACA,6BAAA;EACA,8BAAA;AA5CJ;AA6CI;EACE,iBAAA;AA3CN;AA6CI;EACE,cC71DQ;ED81DR,2CAAA;EACA,4BAAA;EACA,0BAAA;AA3CN;;AA+CA;EACE,mBAAA;AA5CF;;AA8CA;EACE,gCAAA;EACA,uBAAA;AA3CF;;AA6CA;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AA1CF;AA2CE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzCJ;;AA4CA;EACE,aAAA;EACA,mBAAA;AAzCF;;AA2CA;EACE,sBAAA;AAxCF;;AA0CA;EACE,aAAA;EACA,uBAAA;AAvCF;;AAyCA;EACE,aAAA;EACA,6BAAA;AAtCF;;AAwCA;EACE,aAAA;AArCF;;AAuCA;EACE,8BAAA;AApCF;;AAsCA;EACE,yBAAA;AAnCF;;AAqCA;EACE,SAAA;AAlCF;;AAoCA;EACE,6BAAA;AAjCF;;AAmCA;EACE,6BAAA;AAhCF;;AAkCA;EACE,2BAAA;AA/BF;;AAiCA;EACE,8BAAA;AA9BF;;AAgCA;EACE,2BAAA;AA7BF;;AA+BA;EACE,8BAAA;AA5BF;;AA8BA;EACE,8BAAA;AA3BF;;AA6BA;EACE,2BAAA;AA1BF;;AA4BA;EACE,iBAAA;AAzBF;;AA2BA;EACE,aC56DY;ADo5Dd;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBF;;AAyBA;EACE,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtBF;AAuBE;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,4CAAA;EACA,2BAAA;AArBJ;AAuBE;EACE,cCp8DU;EDq8DV,eAAA;EACA,iBAAA;EACA,iBAAA;AArBJ;AAuBE;EACE,cC18DU;ED28DV,eAAA;EACA,iBAAA;EACA,iBAAA;AArBJ;AAuBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AArBJ;AAuBE;EACE,cCn9DS;EDo9DT,gDAAA;UAAA,wCAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AArBJ;AAsBI;EACE,gDAAA;UAAA,wCAAA;AApBN;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cCp+DS;EDq+DT,kBAAA;EACA,uBAAA;EACA,uCAAA;AArBJ;AAsBI;EACE,eAAA;EACA,cCj/DS;EDk/DT,uCAAA;AApBN;AAqBM;EACE,qBAAA;AAnBR;AAuBE;EACE,0BAAA;EACA,yBAAA;EACA,0CAAA;EACA,+BAAA;AArBJ;AAuBE;EACE,0BAAA;EACA,0CAAA;EACA,yBAAA;AArBJ;AAwBI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,6CAAA;AAtBN;AAwBI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;EACA,qCAAA;EACA,6CAAA;AAtBN;AAwBI;EACE,yBAAA;AAtBN;AAwBI;EACE,WAAA;AAtBN;AAuBM;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;AArBR;AAsBQ;EAEE,oBAAA;AArBV;AAwBM;EACE,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,cCniEM;AD6gEd;AA0BE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cC7iEU;ED8iEV,yBChjEW;EDijEX,0BAAA;EACA,2CAAA;EACA,8BAAA;AAxBJ;AAyBI;EACE,yBCrjES;AD8hEf;AA0BE;EACE,WAAA;EACA,yBCtjEW;EDujEX,qBAAA;AAxBJ;AA0BE;EACE,cC3jEU;ED4jEV,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAxBJ;AA0BE;EACE,cChkES;EDikET,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AAxBJ;;AA2BA;EACE,gCAAA;AAxBF;;AA0BA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;EACA,2BAAA;AAvBF;AAwBE;EACE,aCvlES;ADikEb;;AAyBA;EACE,kBAAA;EACA,mBAAA;AAtBF;;AAwBA;EACE,iBAAA;EACA,oBAAA;AArBF;;AAuBA;EACE,YAAA;AApBF;;AAsBA;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,8BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AApBF;AAyBI;EACE,WAAA;EACA,WAAA;EACA,yBC/nES;EDgoET,WAAA;EACA,kBAAA;EACA,SAAA;AAvBN;;AA4BA;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,8BAAA;EACA,4BAAA;AAzBF;;AA6BI;EACE,YAAA;EACA,aAAA;AA1BN;AA6BI;EACE,yBAAA;EACA,6CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,8BAAA;AA3BN;AA6BI;EACE,yBAAA;EACA,6CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;AA3BN;AA6BI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EAEA,8BAAA;EACA,kBAAA;AA5BN;AA8BI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EAEA,6BAAA;EACA,kBAAA;AA7BN;AA+BI;EACE,yBAAA;EACA,gDAAA;UAAA,wCAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;AA7BN;;AAiCA;EACE,8BAAA;AA9BF;AA+BE;EACE,iBAAA;EACA,4BAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;AA7BJ;AA8BI;EACE,eAAA;AA5BN;AA8BI;EACE,gBAAA;EACA,gCAAA;AA5BN;AA6BM;EACE,eAAA;EACA,aCjtEM;EDktEN,eAAA;AA3BR;;AAgCA;EACE,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,4BAAA;EACA,2CAAA;EACA,2DAAA;UAAA,mDAAA;AA7BF;;AA+BA;EACE,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EACA,4BAAA;AA5BF;;AA8BA;EACE,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EACA,4BAAA;AA3BF;;AA6BA;EACE,2CAAA;AA1BF;AA2BE;EACE,yBAAA;EACA,yCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAzBJ;AA2BE;EACE,0BAAA;EACA,gBAAA;EACA,2CAAA;EACA,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAzBJ;AA0BI;EACE,mDAAA;EACA,yBAAA;AAxBN;AA0BI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAxBN;;AA4BA;EACE,aAAA;AAzBF;AA0BE;EACE,iBAAA;EACA,8BAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAxBJ;AAyBI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AAvBN;;AA2BA;EACE,aAAA;EACA,gBAAA;AAxBF;AAyBE;EACE,iBAAA;EACA,8BAAA;EACA,yBAAA;EACA,4CAAA;AAvBJ;AAyBI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,4BAAA;EACA,gCAAA;AAvBN;AAyBI;EACE,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,eAAA;AAvBN;AAwBM;EACE,yBAAA;EACA,0BAAA;EACA,0CAAA;EACA,iBAAA;AAtBR;AAwBM;EACE,yBAAA;EACA,0BAAA;EACA,2CAAA;EACA,iBAAA;AAtBR;AAyBI;EACE,8BAAA;EACA,yBCh1EQ;ADyzEd;AAwBM;EACE,yBAAA;EACA,uCAAA;AAtBR;AAwBM;EACE,yBAAA;AAtBR;AAyBI;EACE,sBAAA;AAvBN;AAwBM;EACE,8BAAA;AAtBR;AAwBM;EACE,2CAAA;AAtBR;AAwBM;EACE,2CAAA;AAtBR;AAyBI;EACE,2BAAA;AAvBN;AAwBM;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;AAtBR;AAuBQ;EACE,yBAAA;EACA,0BAAA;EACA,0CAAA;EACA,iBAAA;AArBV;AAwBM;EACE,yBAAA;AAtBR;;AA2BA;EACE,gBAAA;AAxBF;AAyBE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAvBJ;;AA2BA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAxBF;;AA0BA;EACE,6BAAA;AAvBF;;AAyBA;EACE,4BAAA;AAtBF;;AAwBA;EACE,4BAAA;AArBF;;AAuBA;EACE,4BAAA;AApBF;;AAsBA;EACE,2BAAA;AAnBF;;AAuBI;EACE,yBAAA;AApBN;AAuBE;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AArBJ;;AAwBA;EACE,+BAAA;AArBF;;AAuBA;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,0BAAA;EACA,qBAAA;AApBF;;AAsBA;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;AAnBF;;AAqBA;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gDAAA;UAAA,wCAAA;EACA,eAAA;EACA,0BAAA;AAlBF;;AAoBA;EACE,kBAAA;AAjBF;;AAmBA;EACE,SAAA;AAhBF;;AAkBA;EACE,6BAAA;AAfF;;AAiBA;EACE,4BAAA;AAdF;;AAgBA;EACE,YAAA;EACA,WAAA;EACA,yBC98EW;ED+8EX,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAbF;;AAeA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAZF;;AAcA;EACE,aAAA;EACA,YAAA;EACA,yBCn+EW;EDo+EX,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAXF;;AAaA;EACE,iBAAA;AAVF;;AAYA;EACE,2BAAA;AATF;;AAWA;EACE,2BAAA;AARF;;AAUA;EACE,kBAAA;EACA,mBAAA;AAPF;;AASA;EACE,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;AANF;;AAQA;EACE,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;AALF;;AAOA;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAJF;;AAOE;EACE,yBCzhFW;ADqhFf;;AAOA;EACE,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,oBAAA;AAJF;AAKE;EACE,uBAAA;EACA,sBAAA;EACA,kDAAA;EACA,oCAAA;EACA,eAAA;EACA,uFACE;AAJN;AAOE;EACE,yBCxiFS;ADmiFb;AAOE;EACE,oCAAA;EACA,qBAAA;AALJ;AAOE;EACE,uBAAA;AALJ;;AASE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cC3jFU;ED4jFV,yBC9jFW;ED+jFX,0BAAA;EACA,2CAAA;EACA,8BAAA;AANJ;AAOI;EACE,yBCnkFS;AD8jFf;AASE;EAWE,kBAAA;AAjBJ;AAOI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,6CAAA;AALN;AAOI;EACE,yBAAA;AALN;AAQI;EACE,WAAA;AANN;AAOM;EACE,wBAAA;AALR;AAOM;EACE,uBAAA;EACA,6BAAA;EACA,yBAAA;AALR;AAMQ;EAEE,oBAAA;AALV;AAQM;EACE,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,cClmFM;AD4lFd;AAOQ;EACE,yCAAA;AALV;AASI;EACE,WAAA;AAPN;AAQM;EACE,wBAAA;AANR;AAQM;EACE,uBAAA;EACA,6BAAA;EACA,yBAAA;AANR;AAOQ;EAEE,oBAAA;AANV;AASM;EACE,kBAAA;EACA,0BAAA;EACA,2CAAA;EACA,cC1nFM;ADmnFd;;AAYA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;EACA,uCAAA;EACA,8BAAA;AATF;AAUE;EACE,yBCloFQ;AD0nFZ;AAUE;EACE,yBCpoFiB;AD4nFrB;;AAWA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;EACA,uCAAA;EACA,8BAAA;AARF;AASE;EACE,yBC5pFW;ADqpFf;AASE;EACE,yBC9pFoB;ADupFxB;;AAUA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;EACA,uCAAA;EACA,8BAAA;AAPF;AAQE;EACE,yBCvqFS;ADiqFb;;AASA;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,gCAAA;EACA,4BAAA;EACA,yBAAA;AANF;;AAQA;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;AALF;;AAOA;EACE,wBAAA;EACA,eAAA;AAJF;;AAMA;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAHF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,0BAAA;EACA,iCAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;AAFF;;AAIA;EACE,8BAAA;AADF;AAGE;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;AADJ;AAGE;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;AADJ;AAGE;EACE,aCvuFU;EDwuFV,0BAAA;AADJ;AAGE;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;AADJ;;AAIA;EACE,aAAA;AADF;;AAIE;EACE,8BAAA;AADJ;;AAKE;EACE,8BAAA;AAFJ;;AAME;EACE,8BAAA;AAHJ;;AAMA;EACE,kBAAA;AAHF;;AAKA;EACE,eAAA;AAFF;;AAIA;EACE,sCAAA;EACA,kDAAA;EACA,mBAAA;AADF;AAEE;EACE,yBC1wFS;AD0wFb;AAEE;EACE,0BAAA;AAAJ;AAEE;EACE,wBAAA;EACA,iBAAA;AAAJ;AACI;EACE,yBAAA;EACA,0BAAA;EACA,yCAAA;EACA,4BAAA;EACA,8BAAA;AACN;AACI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;EACA,eAAA;EACA,8BAAA;AACN;AACI;EACE,yBAAA;EACA,yCAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;AACN;;AAGA;EACE,0BAAA;EACA,cClzFY;EDmzFZ,kBAAA;EACA,uBAAA;EACA,uCAAA;EACA,gBAAA;AAAF;;AAEA;EACE,0BAAA;EACA,cC5zFa;ED6zFb,uCAAA;AACF;AAAE;EACE,qBAAA;AAEJ;;AACA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,6BAAA;EACA,YAAA;AAEF;AADE;EACE,oCAAA;AAGJ;;AACE;EACE,eAAA;EACA,2BAAA;AAEJ;;AAEE;EACE,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;AACJ;;AAEA;;EAEE,wBAAA;AACF;;AAEE;EACE,eAAA;EACA,2BAAA;AACJ;AACE;EACE,0BAAA;AACJ;AAEI;EACE,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;AAAN;;AAIA;EAEI;IACE,qBAAA;IACA,sBAAA;IACA,sBAAA;IACA,2BAAA;EAFJ;AACF;AAOA;EACE,aAAA;AALF;AAME;EACE,mBAAA;EACA,4BAAA;EACA,yBAAA;EACA,2CAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAKI;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AAHN;AAIM;EACE,gDAAA;AAFR;AAKI;EACE,aAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;AAHN;AAKI;EACE,WAAA;AAHN;AAME;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAKI;EAEE,sBAAA;AAJN;AAOI;EACE,sBAAA;EACA,QAAA;EACA,MAAA;AALN;AAOI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AALN;AAOI;EACE,0BAAA;AALN;AAOI;EACE,yBAAA;EACA,0CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AALN;AAOI;EACE,gCAAA;EACA,8BAAA;EACA,gBAAA;AALN;AAOI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AALN;AAOI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;AALN;AAOI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;AALN;AAOI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;AALN;AAOI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;AALN;AAOI;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AALN;AAOI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AALN;AAOI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AALN;AAQI;EACE,eAAA;EACA,gBAAA;AANN;AAQI;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AANN;AAOM;EACE,gDAAA;AALR;AAQI;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,0BAAA;AANN;AASI;EACE,WAAA;AAPN;;AAYA;EACE,0BAAA;EACA,8BAAA;EACA,YAAA;EACA,cC3hGW;ED4hGX,yBCjiGY;EDkiGZ,YAAA;EACA,mBAAA;EACA,qBAAA;AATF;AAUE;EAAiC,4BAAA;AAPnC;;AAUA;EACE,0BAAA;EACA,YAAA;EACA,cCtiGW;EDuiGX,yBC5iGY;ED6iGZ,YAAA;EACA,mBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,cAAA;AAPF;;AAUA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cCxkGW;EDykGX,YAAA;EACA,kBAAA;AAPF;;AAUA;EACE,4BAAA;AAPF;AAQE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,2CAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AANJ;AAOI;EACE,WAAA;EACA,UAAA;AALN;AAOI;EACE,YAAA;AALN;AAQE;EACE,yBAAA;EACA,2CAAA;AANJ;AAQE;EACE,yBAAA;EACA,gCAAA;AANJ;AAQE;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AANJ;AAOI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AALN;AAOI;EACG,mBAAA;AALP;AAMM;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAQI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AANN;AAQI;EACE,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AANN;AAOK;EACG,YAAA;EACA,gBAAA;AALR;AAQI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AANN;AAQI;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;AANN;AAQI;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AANN;AASE;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AAQI;EACE,sBAAA;AANN;AAQI;EACE,sBAAA;EACA,QAAA;EACA,MAAA;AANN;AAQI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AANN;AAQI;EACE,0BAAA;AANN;AAQI;EACE,yBAAA;EACA,0CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AANN;AAQI;EACE,yBAAA;EACA,0CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AANN;AAQI;EACE,gCAAA;EACA,8BAAA;EACA,gBAAA;AANN;AAQI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AANN;AAQI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;AANN;AAQI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;AANN;AAQI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;AANN;AAQI;EACE,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;AANN;AAQI;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AANN;AAQI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AANN;AAQI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AANN;AAQI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AANN;AAQI;EACE,eAAA;EACA,gBAAA;AANN;;AAUA;;EAEE,kBAAA;AAPF;AAQE;;EACE,wBAAA;AALJ;AAOE;;EAEE,kBAAA;AALJ;AAMI;;EACE,UAAA;AAHN;AAKI;;EACE,kBAAA;AAFN;AAGM;;EACE,UAAA;EACA,yBC/zGO;EDg0GP,kBAAA;EACA,OAAA;EACA,SAAA;EACA,MAAA;EACA,qBAAA;EACA,YAAA;AAAR;AAEM;;EACE,yBAAA,EAAA,+BAAA;AACR;AACM;;EACE,kBAAA;AAER;AAAM;;EACE,mBAAA;EACA,oBAAA;EACA,eAAA;AAGR;AAAM;;EACE,mBCp1GO;EDq1GP,oBAAA;EACA,eAAA;AAGR;;AAEA;EACE,2BAAA;EACA,gBAAA;AACF;;AACA;EACE,sBAAA;AAEF;AAAI;EACE,aAAA;AAEN;AACE;EACE,sBAAA;AACJ;AACE;EACE,6BAAA;AACJ;AAEI;EACE,8BAAA;AAAN;AAEI;EACE,6BAAA;AAAN;;AAIA;EACE,WAAA;EACA,2CAAA;EACA,2BAAA;EACA,WAAA;AADF;;AAGA;EACE,WAAA;AAAF;;AAEA;EACE,YAAA;EACA,yBC73GY;ED83GZ,WAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AACA;EACE,YAAA;EACA,yBC/3GY;EDg4GZ,WAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AAAA;EACE,8BAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,2BAAA;AAKF;AAJE;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAMJ;AALI;EACE,yBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAON;AALI;EACE,eAAA;EAKA,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAGN;AAXM;EACE,aCp6GO;EDq6GP,mBAAA;AAaR;AALI;EACE,eAAA;EAKA,yBAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAGN;AAXM;EACE,aCt6GI;EDu6GJ,mBAAA;AAaR;AALI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAON;AANM;EACE,aAAA;AAQR;AALI;EACE,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAON;;AAHA;EACC,yBAAA;EACK,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAMN;;AAJA;EACE,wBAAA;EACA,0BAAA;EACA,8BAAA;AAOF;;AALA;EACI,wBAAA;EACA,0BAAA;EACA,8BAAA;AAQJ;;AANA;EACE,yBAAA;EACE,wBAAA;EACA,0BAAA;EACA,8BAAA;AASJ;;AAPA;EACI,cC99GS;ED+9GT,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAUJ;;AARA;EACE,iBAAA;EACE,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAWJ;;AATA;EACE;IACE,sBAAA;EAYF;EATE;IACE,0BAAA;IACA,6BAAA;EAWJ;AACF;AARA;EACE;IACE,aAAA;EAUF;EARA;IACE,wBAAA;EAUF;AACF;AAPE;EACE,uBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sDAAA;EACA,4BAAA;AASJ;AARI;EACE,4BAAA;EACA,gCAAA;AAUN;AARI;EACE,cC3gHO;ED4gHP,eAAA;EACA,yCAAA;EACA,iBAAA;EACA,iBAAA;AAUN;AARI;EACE,gBAAA;EACA,oCAAA;AAUN;AARI;EACE,cCxhHQ;EDyhHR,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAUN;AARI;EACE,cC/hHQ;EDgiHR,eAAA;EACA,iBAAA;EACA,iBAAA;AAUN;AARI;EACE,cCniHO;EDoiHP,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;AAUN;AARI;EACE,2BAAA;AAUN;AARI;EACE,YAAA;EACA,WAAA;EACA,yBC7iHO;ED8iHP,kBAAA;EACA,cCpjHQ;EDqjHR,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAUN;AARI;EACE,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAUN;AARI;EACE,cC/jHO;EDgkHP,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;AAUN;AARI;EACE,cCxkHQ;EDykHR,eAAA;EACA,iBAAA;EACA,iBAAA;AAUN;AARI;EACE,cC9kHQ;ED+kHR,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAUN;AARI;EACE,2BAAA;AAUN;AARI;EACE,4BAAA;AAUN;AARI;EACE,4BAAA;AAUN;AATM;EACE,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;AAWR;AATQ;EACE,cCrmHI;EDsmHJ,eAAA;EACA,iBAAA;EACA,iBAAA;AAWV;AATQ;EACE,cC3mHI;ED4mHJ,eAAA;EACA,iBAAA;EACA,iBAAA;AAWV;AATQ;EACE,cCjnHI;EDknHJ,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,uCAAA;AAWV;AAPI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AASN;;AALA;EACE,cCjoHW;EDkoHX,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,gDAAA;UAAA,wCAAA;EACA,yCAAA;EACA,eAAA;AAQF;;AANA;EACE,cC1oHW;ED2oHX,eAAA;EACA,yCAAA;EACA,iBAAA;EACA,iBAAA;AASF;;AAPA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0CAAA;EACA,2BAAA;AAUF;AATE;EACE,iBAAA;EACA,+BAAA;EACA,iBAAA;AAWJ;AATE;EACE,iBAAA;EACA,iBAAA;AAWJ;AATE;EACE,aAAA;EACA,eAAA;EACA,6BAAA;AAWJ;AATE;EACE,yBAAA;EACA,aC5qHW;ED6qHX,eAAA;EACA,6BAAA;AAWJ;AATE;EACE,cC5qHS;ED6qHT,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAWJ;AATE;EACE,cCprHS;EDqrHT,eAAA;EACA,yCAAA;EACA,iBAAA;EACA,iBAAA;AAWJ;AATE;EACE,cC7rHU;ED8rHV,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAWJ;;AARA;EACE,wBAAA;AAWF;;AARA;EACE,8BAAA;EACA,wBAAA;EACA,6BAAA;EACA,oCAAA;AAWF;AAVE;EACE,YAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;AAVE;EACE,cAAA;AAYJ;AAVE;EACE,cAAA;AAYJ;AAVE;EACE,cAAA;AAYJ;AAVE;EACE,cAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;AAVE;EACE,yBAAA;AAYJ;;AARA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EAGA,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AASF;;AANA;EACE,yBAAA;EACA,0BAAA;EACA,yCAAA;EACA,4BAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,4BAAA;EACA,gCAAA;EACA,uBAAA;AASF;;AAPA;EACE,yBAAA;EACA,0BAAA;EACA,2CAAA;EACA,4BAAA;EACA,8BAAA;AAUF;;AARA;EACE,oCAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;AAWF;;AATA;EACE,qBAAA;EACA,0BAAA;EACA,2CAAA;EACA,4BAAA;EACA,0BAAA;AAYF;;AAVA;EACE,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;AAaF;;AAXA;EACE,yBAAA;EACA,0BAAA;EACA,2CAAA;EACA,4BAAA;EACA,4BAAA;AAcF;;AAXA;EACE,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,iBAAA;EACA,0BAAA;EACA,qCAAA;EACA,6CAAA;EACA,0BAAA;AAcF;;AAXA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,cAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EAIA,uCAAA;EACA,mBAAA;AAUF","sourcesContent":["@import '_variable.scss';\n\n@font-face {\n  font-family: 'TwCenMTStd-Regular';\n  src:\n    local('TwCenMTStd-Regular'),\n    url('../assets/font/TwCenMTStd.otf') format('opentype');\n  // font-weight: 400;\n}\n@font-face {\n  font-family: 'TwCenMTStd-SemiBold';\n  src:\n    local('TwCenMTStd-SemiBold'),\n    url('../assets/font/TwCenMTStdSemiBold.otf') format('opentype');\n  // font-weight: 600;\n}\n@font-face {\n  font-family: 'TwCenMTStd-Medium';\n  src:\n    local('TwCenMTStd-Medium'),\n    url('../assets/font/TwCenMTStdSemiMedium.otf') format('opentype');\n  // font-weight: 500;\n}\n@font-face {\n  font-family: 'TwCenMTStd-SemiMedium';\n  src:\n    local('TwCenMTStd-Medium'),\n    url('../assets/font/TwCenMTStdSemiMedium.otf') format('opentype');\n  // font-weight: 400;\n}\n@font-face {\n  font-family: 'TwCenMTStd-Italic';\n  src:\n    local('TwCenMTStd-Italic'),\n    url('../assets/font/TwCenMTStdItalic.otf') format('opentype');\n  // font-weight: 500;\n}\n@font-face {\n  font-family: 'TwCenMTStd-Light';\n  src:\n    local('TwCenMTStd-Light'),\n    url('../assets/font/TwCenMTStdLight.otf') format('opentype');\n  // font-weight: 300;\n}\n@font-face {\n  font-family: 'TwCenMTStd-Bold';\n  src:\n    local('TwCenMTStd-Bold'),\n    url('../assets/font/TwCenMTStdBold.otf') format('opentype');\n  // font-weight: bold;\n}\nbody {\n  box-sizing: border-box;\n  margin: 0px;\n  padding: 0px;\n}\nbody,\ndiv,\nspan,\nlabel,\ninput,\ntextarea,\na,\noption,\nli,\np,\nth,\ntd,\nbutton {\n  font-family: TwCenMTStd-Regular !important;\n}\nselect {\n  border:1px solid #111;\n  border-radius:3px;  \n  font-family: TwCenMTStd-Regular !important;\n  margin:0px 0px 8px 0px;\n}\n.header-border {\n  border-top: 5px solid $theme-coclor;\n  z-index: 1001 !important;\n}\n@media only screen and (min-height: 800px) {\n  .sidebar-footer {\n    position: absolute;\n    bottom: 15px;\n    width: 100%;\n  }\n}\n@media only screen and (min-height: 400px) {\n  .admin-sidebar-footer {\n    position: absolute;\n    bottom: 15px;\n    width: 100%;\n  }\n}\nbody > iframe {\n  display: none;\n}\n.search {\n  margin-right: 25px !important;\n}\n.filter {\n  font-size: 32px !important;\n  cursor: pointer;\n}\n.pr-16 {\n  padding-right: 16px;\n}\n.pr-8 {\n  padding-right: 8px;\n}\n.mr-10 {\n  margin-right: 10px !important;\n}\n.mr-16 {\n  margin-right: 16px !important;\n}\n.bg-white {\n  background-color: $white-color;\n}\n.hrmonth-chart {\n  .recharts-legend-wrapper {\n    top: -45px !important;\n    width: auto !important;\n    right: 56px !important;\n    min-width: unset !important;\n  }\n}\n.filter-popup {\n  .MuiPaper-root {\n    min-height: 96.9px;\n    width: 320px;\n    border-radius: 8px !important;\n    background-color: $pop-color !important;\n    box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.22) !important;\n    overflow: unset !important;\n    padding: 15px 0px 11px 16px;\n    margin-top: 15px;\n  }\n  .mb-6 {\n    margin-bottom: 6px;\n  }\n  .filter-text-grey {\n    color: $grey-color !important;\n    font-size: 14px !important;\n    letter-spacing: 0;\n    line-height: 21px !important;\n  }\n  .filter-text {\n    color: $white-color !important;\n    font-size: 24px !important;\n    letter-spacing: 0;\n    line-height: 21px !important;\n  }\n  .reset-text {\n    color: $purple-color !important;\n    font-family: TwCenMTStd-SemiBold !important;\n    font-size: 15px !important;\n    letter-spacing: 0;\n    line-height: 14px !important;\n    text-decoration: underline solid $purple-color;\n    cursor: pointer;\n  }\n  .scroll-box {\n    max-height: 83vh;\n    overflow-y: auto;\n    padding-right: 16px;\n    .custom-field {\n      .select-button-filter {\n        margin-top: 6px;\n        width: 100%;\n        background-color: $white-color;\n        justify-content: space-between;\n        height: 40px;\n        border-radius: 5px;\n        .filter-select-title {\n          text-transform: capitalize;\n          margin-left: 5px !important;\n          color: black !important;\n          font-size: 15px !important;\n          font-family: TwCenMTStd-SemiBold !important;\n        }\n        .filter-select-count {\n          text-align: center;\n          display: flex;\n          align-self: center;\n          .filter-select-count-text {\n            color: #0061ff !important;\n            font-size: 16px !important;\n            font-family: TwCenMTStd-SemiBold !important;\n            margin-right: 5px !important;\n          }\n          .select-arrow {\n            fill: $label-color !important;\n          }\n        }\n      }\n      p {\n        color: $white-color !important;\n        font-size: 12px !important;\n        letter-spacing: 0;\n        line-height: 24px !important;\n      }\n      margin-bottom: 8px;\n      .custom-input {\n        width: 100%;\n        .MuiOutlinedInput-notchedOutline {\n          border: unset !important;\n        }\n        .MuiInputBase-root {\n          height: 43px !important;\n          border-radius: 7px !important;\n          background-color: #f8f8fa;\n          &::before,\n          &::after {\n            border-bottom: unset;\n          }\n        }\n        .MuiSelect-select {\n          padding-right: 100px !important;\n        }\n        .MuiInputBase-input {\n          padding: 13px 11px;\n          font-size: 15px !important;\n          font-family: TwCenMTStd-SemiBold !important;\n          color: $label-color;\n        }\n        // .MuiSelect-multiple {\n        //   margin-right: 100px !important;\n        // }\n      }\n    }\n  }\n  .arrow-top {\n    width: 20px;\n    height: 20px;\n    border-radius: 5px;\n    position: absolute;\n    right: 15px;\n    top: -7px;\n    transform: rotate(225deg);\n    background-color: $pop-color;\n  }\n  .pop-item {\n    color: $white-color !important;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 32px;\n    cursor: pointer;\n  }\n}\n.edit-popup {\n  .MuiPaper-root {\n    min-height: 56.9px;\n    min-width: 207px;\n    border-radius: 8px !important;\n    background-color: $pop-color !important;\n    box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.22) !important;\n    overflow: unset !important;\n    padding: 15px 16px 11px 16px;\n  }\n  .mb-6 {\n    margin-bottom: 6px;\n  }\n  .arrow-top {\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    right: 15px;\n    top: -7px;\n    transform: rotate(225deg);\n    background-color: $pop-color;\n  }\n  .pop-item {\n    color: $white-color !important;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 32px;\n    cursor: pointer;\n  }\n}\n.MuiTableContainer-root {\n  box-shadow: unset !important;\n  background-color: unset !important;\n}\n.employee-legent {\n  .opt-text {\n    color: $label-color !important;\n    font-size: 14px !important;\n    margin-left: 6px !important;\n  }\n  .opt-text2 {\n    color: $label-color !important;\n    font-size: 15px !important;\n    margin-left: 6px !important;\n  }\n  .opt-box {\n    height: 16px;\n    width: 16px;\n    &.rs {\n      background-color: $theme-coclor;\n    }\n    &.gs {\n      background-color: $blue-color;\n    }\n    &.na {\n      background-color: $purple-color;\n    }\n  }\n}\n.emp-search-option-tab {\n  height: 32px;\n  width: 230px;\n  border-radius: 8.91px;\n  background-color: $lightgray-color;\n  margin-right: 10px !important;\n  padding-right:8px;\n  position:relative;\n  .emp-search-input {\n    width: 200px;\n    margin-left:10px;\n    .MuiInputBase-root {\n      height: 41px;\n      border-radius: 8px;\n      background-color: $white-color;\n      border: 1px solid #cacaca !important;\n      &::before,\n      &::after {\n        border-bottom: unset;\n      }\n    }\n    .MuiInputBase-input {\n      padding: 13px 11px;\n      font-size: 15px !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      color: $label-color;\n    }    \n  }\n  .emp-search-button{\n    font-size:small;\n    background-color: $white-color;\n  }\n  .emp-search-button:focus{\n    background-color: $lightgray-color;\n  }\n  .no-suggestions {\n    color: #999;\n    padding: 0.5rem;\n    position: absolute;\n    width: calc(210px + 1rem);\n    top:25px;\n    left:5px;\n  }\n  .suggestions {\n    font-size: 15px !important;\n    font-family: TwCenMTStd-SemiBold !important;\n    background-color: #ffffff;\n    color:#000000;\n    border: 1px solid #999;\n    list-style: none;\n    margin-top: 0px;\n    max-height: 143px;\n    overflow-y: auto;\n    padding-left: 5px;\n    top:32px;\n    left:5px;\n    width: calc(210px + 1rem);\n    position: absolute;\n  }\n  .suggestions li {\n    padding: 0px;\n  }\n  .suggestion-active,\n  .suggestions li:hover {\n    background-color: $lightgray-color;\n    color: #000000;\n    cursor: pointer;\n    order:4\n  }\n  .suggestions li:not(:last-of-type) {\n    border-bottom: 1px solid #999;\n  }\n}\n.view-option-tab {\n  height: 32px;\n  width: 215px;\n  border-radius: 8.91px;\n  background-color: $lightgray-color;\n  margin-right: 17px !important;\n  .tab-btn {\n    width: 50%;\n    height: 29px;\n    font-size: 13px;\n    letter-spacing: 0;\n    line-height: 18px;\n    text-align: center;\n    padding: 5px;\n    cursor: pointer;\n    color: #000000;\n    &.active {\n      border: 0.5px solid rgba(0, 0, 0, 0.04);\n      border-radius: 6.93px;\n      background-color: #ffffff;\n      box-shadow:\n        0 3px 8px 0 rgba(0, 0, 0, 0.12),\n        0 3px 1px 0 rgba(0, 0, 0, 0.04);\n      font-family: TwCenMTStd-SemiBold !important;\n    }\n  }\n}\n.waiticon-modal{\n  position: absolute;\n  z-index:1;\n  &:focus-visible {\n    outline: none;\n  };\n  padding-top:150px;\n  left:300px;\n}\n.dash-modal {\n  position: absolute;\n  &:focus-visible {\n    outline: none;\n  }\n  .c-title {\n    color: #171a33 !important;\n    font-size: 24px !important;\n    letter-spacing: 0;\n    line-height: 21px !important;\n    margin-top: 22px;\n  }\n\n  .dwdBtn {\n    border: 1px solid #d9d9d9 !important;\n    border-radius: 4px !important;\n  }\n}\n.dash-drawer {\n  .MuiPaper-root {\n    width: 438px !important;\n    background-color: #ffffff;\n    box-shadow: -5px 0 10px 0 rgba(0, 0, 0, 0.06) !important;\n    padding: 24px 16px 16px 16px;\n    .citem {\n      min-height: 102px;\n      border-radius: 5px;\n      background-color: #eff5f5;\n      padding: 20px 20px 10px 20px;\n      margin-bottom: 10px;\n      .fnum {\n        color: $label-color;\n        font-size: 25px;\n        font-family: TwCenMTStd-Bold !important;\n        letter-spacing: 0;\n        line-height: 23px;\n      }\n      .snum {\n        color: $grey-color;\n        font-size: 25px;\n        font-family: TwCenMTStd-Bold !important;\n        letter-spacing: 0;\n        line-height: 23px;\n        margin-left: 8px;\n      }\n      .det-info {\n        color: $label-color;\n        font-size: 16px;\n        letter-spacing: 0;\n        line-height: 14px;\n      }\n      .vmore {\n        color: $blue-color;\n        font-size: 12px;\n        font-family: TwCenMTStd-Bold !important;\n        letter-spacing: 0;\n        line-height: 11px;\n        text-decoration: underline solid $blue-color;\n        cursor: pointer;\n        margin-top: 6px;\n      }\n    }\n    .dtitle {\n      color: $pop-color;\n      font-size: 24px;\n      letter-spacing: 0;\n      line-height: 21px;\n    }\n    .dclose {\n      color: $pop-color;\n      font-size: 14px;\n      letter-spacing: 0;\n      line-height: 13px;\n      cursor: pointer;\n      text-decoration: underline solid $pop-color;\n    }\n  }\n}\n.username_detailbox{\n  text-align: left;\n  width: 900px !important;\n  display: flex;\n  .nametext{\n    margin-left:20px;\n    font-weight: bold;\n    font-size:large;  \n    color: $blue-color;  \n  }\n  .viewdetails{\n    margin-left:10px;\n    cursor:pointer;\n    text-decoration: underline;\n    align-self: flex-end;\n  }\n}\n.report-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90vw;\n  height: 90vh;\n  border-radius: 10px;\n  background-color: #ffffff;\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n  overflow: auto;\n  &:focus-visible {\n    outline: none;\n  }\n  .modal-h-pad {\n    padding: 16px 20px 30px 38px;\n  }\n  .close-icon {\n    border-radius: 30px;\n    cursor: pointer;\n  }\n  .modal-title {\n    color: $blue-color !important;\n    font-size: 24px !important;\n    letter-spacing: 0;\n    line-height: 21px !important;\n    text-transform: unset;\n  }\n  .down-box {\n    height: 40px;\n    width: 40px;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n}\n.report-box {\n  min-height: 440px;\n  height: 100%;\n  background-color: #ffffff;\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n  .report-head {\n    min-height: 120px;\n    background-color: $blue-color;\n    border-bottom: 6px solid $theme-coclor;\n    padding: 25px;\n    color: $white-color !important;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 24px !important;\n    letter-spacing: 2px !important;\n    line-height: 22px !important;\n    text-align: center;\n    text-transform: uppercase;\n  }\n  .report-body {\n    padding: 20px 46px;\n    .rb-detail {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      letter-spacing: 0;\n      line-height: 22px !important;\n      margin-bottom: 16px;\n      text-decoration: underline solid #171a33;\n      cursor: pointer;\n    }\n    .rb-detail-disabled {\n      // text-decoration: unset !important;\n      text-decoration-color: #a49c9c !important;\n      cursor: unset !important;\n      color: #a49c9c !important;\n    }\n    .rb-detail:last-child {\n      margin-bottom: unset !important;\n    }\n  }\n}\n.report-table {\n  height: 77vh !important;\n  overflow: scroll !important;\n  thead {\n    .arrow-box {\n      position: relative;\n      margin-left: 3px;\n      height: 10px;\n      width: 7px;\n      .down {\n        position: absolute;\n        bottom: -10px;\n        fill: #d8d8d8;\n        cursor: pointer;\n      }\n      .up {\n        position: absolute;\n        position: absolute;\n        top: -10px;\n        fill: #d8d8d8;\n        cursor: pointer;\n      }\n    }\n    th:first-child {\n      padding-left: 20px;\n    }\n    th {\n      padding: 10px 10px 7px 10px;\n      background: #f8f8fa;\n      border-bottom: unset;\n    }\n    th,\n    .th-title {\n      color: #000000;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 14px !important;\n      letter-spacing: 0;\n      line-height: 11px;\n    }\n  }\n  tbody {\n    tr:nth-child(odd) {\n      background: #e8e8e8 !important;\n    }\n    tr:nth-child(even) {\n      background: #ffffff !important;\n    }\n    td:first-child {\n      padding-left: 20px;\n    }\n    td {\n      padding: 5px 10px;\n      color: $label-color !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      transition: 0.5s;\n      min-height: 24px;\n      border-bottom: unset;\n      .btn-over {\n        display: none;\n        transition: 0.5s;\n      }\n      button {\n        padding: unset !important;\n        svg {\n          fill: $label-color !important;\n        }\n      }\n    }\n    tr {\n      transition: 0.5s;\n      background: #f8f8fa;\n      .last-td {\n        position: fixed;\n        right: 0;\n        border-bottom: unset !important;\n      }\n      &:hover {\n        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n        .btn-over {\n          display: flex !important;\n        }\n      }\n    }\n    .company-name {\n      color: $label-color !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 14px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      max-width: 280px;\n    }\n  }\n}\n.ld-table {\n  thead {\n    .arrow-box {\n      position: relative;\n      margin-left: 3px;\n      height: 10px;\n      width: 7px;\n      .down {\n        position: absolute;\n        bottom: -10px;\n        fill: #d8d8d8;\n        cursor: pointer;\n      }\n      .up {\n        position: absolute;\n        position: absolute;\n        top: -10px;\n        fill: #d8d8d8;\n        cursor: pointer;\n      }\n    }\n    th:first-child {\n      padding-left: 20px;\n    }\n    th {\n      padding: 10px 10px 7px 10px;\n      background: #f8f8fa;\n      border-bottom: unset;\n    }\n    th,\n    .th-title {\n      color: $grey-color;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 12px !important;\n      letter-spacing: 0;\n      line-height: 11px;\n    }\n  }\n  tbody {\n    tr:nth-child(even) {\n      background: #f8f8fa !important;\n    }\n    tr:nth-child(odd) {\n      background: #ffffff !important;\n    }\n    td:first-child {\n      padding-left: 20px;\n    }\n    td {\n      padding: 11.5px 10px;\n      color: $label-color !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      transition: 0.5s;\n      height: 40px;\n      border-bottom: unset;\n      .btn-over {\n        display: none;\n        transition: 0.5s;\n      }\n      button {\n        padding: unset !important;\n        svg {\n          fill: $label-color !important;\n        }\n      }\n    }\n    tr {\n      transition: 0.5s;\n      background: #f8f8fa;\n      .last-td {\n        position: fixed;\n        right: 0;\n        border-bottom: unset !important;\n      }\n      &:hover {\n        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n        .btn-over {\n          display: flex !important;\n        }\n      }\n    }\n    .company-name {\n      color: $label-color !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      max-width: 280px;\n    }\n  }\n}\n.companie-table {\n  .pl-62 {\n    padding-left: 52px !important;\n  }\n  thead {\n    .arrow-box {\n      position: relative;\n      margin-left: 3px;\n      height: 10px;\n      width: 7px;\n      .down {\n        position: absolute;\n        bottom: -10px;\n        fill: #d8d8d8;\n        cursor: pointer;\n      }\n      .up {\n        position: absolute;\n        position: absolute;\n        top: -10px;\n        fill: #d8d8d8;\n        cursor: pointer;\n      }\n    }\n    th:first-child {\n      padding-left: 20px;\n    }\n    th {\n      padding: 10px 10px 7px 10px;\n      background: #f8f8fa;\n    }\n    th,\n    .th-title {\n      color: $grey-color;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 12px !important;\n      letter-spacing: 0;\n      line-height: 11px;\n    }\n  }\n  \n  tbody {\n    .custom-field {\n      .custom-input {\n        width: 400px;\n        .MuiInputBase-root {\n          height: 41px;\n          border-radius: 8px;\n          background-color: $white-color;\n          border: 1px solid #cacaca !important;\n          &::before,\n          &::after {\n            border-bottom: unset;\n          }\n        }\n        .MuiInputBase-input {\n          padding: 13px 11px;\n          font-size: 15px !important;\n          font-family: TwCenMTStd-SemiBold !important;\n          color: $label-color;\n        }\n      }\n    }\n    .d-avtaor {\n      height: 32px;\n      width: 32px;\n      background-color: $blue-color;\n      border-radius: 50%;\n      color: $white-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      margin-right: 10px;\n    }\n    .ivited-badge {\n      height: 24px;\n      width: 67px;\n      border-radius: 17px;\n      background-color: $blue-color;\n      color: $white-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 12px !important;\n      text-transform: uppercase;\n      letter-spacing: 0.75px;\n      line-height: 13px;\n      text-align: center;\n      padding: 6px 10px;\n    }\n    .decative-badge {\n      height: 24px;\n      width: 68px;\n      border-radius: 17px;\n      background-color: #a70d0d;\n      color: $white-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 12px !important;\n      text-transform: uppercase;\n      letter-spacing: 0;\n      line-height: 13px;\n      text-align: center;\n      padding: 6px 10px;\n    }\n    .mr-6 {\n      margin-right: 6.5px;\n    }\n    .edit-btn {\n      height: 40px;\n      min-width: 71px !important;\n      border: 1px solid $grey-color !important;\n      border-radius: 8px !important;\n      background-color: $white-color !important;\n      color: $label-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      text-transform: capitalize !important;\n      text-align: center;\n      padding-left: 16px !important;\n      padding-right: 14px !important;\n    }\n    .add-btn {\n      height: 40px;\n      min-width: 70px !important;\n      border: 1px solid $blue-color !important;\n      border-radius: 8px !important;\n      background-color: $blue-color !important;\n      color: $white-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      text-transform: capitalize !important;\n      text-align: center;\n      padding-left: 16px !important;\n      padding-right: 14px !important;\n    }\n    .active-badge {\n      height: 24px;\n      width: 62px;\n      border-radius: 17px;\n      background-color: $theme-coclor;\n      color: $white-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 12px !important;\n      text-transform: uppercase;\n      letter-spacing: 0.75px;\n      line-height: 13px;\n      text-align: center;\n      padding: 6px 10px;\n    }\n    td:first-child {\n      padding-left: 20px;\n    }\n    td {\n      padding: 11.5px 10px;\n      color: $label-color !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      transition: 0.5s;\n      height: 56px;\n      .btn-over {\n        display: none;\n        transition: 0.5s;\n      }\n      button {\n        padding: unset !important;\n        svg {\n          fill: $label-color !important;\n        }\n      }\n    }\n    tr {\n      transition: 0.5s;\n      background: #f8f8fa;\n      .last-td {\n        position: fixed;\n        right: 0;\n        border-bottom: unset !important;\n      }\n      &:hover {\n        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n        .btn-over {\n          display: flex !important;\n        }\n      }\n    }\n    .company-name {\n      color: $label-color !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      max-width: 280px;\n    }\n  }\n}\n.employee-table {\n  .border-right {\n    border-right: 1px solid #d8d8d8;\n  }\n  .border-bottom {\n    border-right: 1px solid #d8d8d8;\n  }\n  .body-content {\n    .MuiGrid-item {\n      border-right: 1px solid #d8d8d8;\n    }\n  }\n  .arrow-box {\n    position: relative;\n    margin-left: 3px;\n    height: 10px;\n    width: 7px;\n    .down {\n      position: absolute;\n      bottom: -10px;\n      fill: #d8d8d8;\n      cursor: pointer;\n    }\n    .up {\n      position: absolute;\n      position: absolute;\n      top: -10px;\n      fill: #d8d8d8;\n      cursor: pointer;\n    }\n  }\n  .h-69 {\n    height: 69px;\n    padding: 0 24px;\n    background: #f8f8fa;\n  }\n  th,\n  .th-title {\n    color: $label-color;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 24px !important;\n    letter-spacing: 0;\n    line-height: 22px;\n  }\n  .d-avtaor {\n    height: 32px;\n    width: 32px;\n    background-color: $blue-color;\n    border-radius: 50%;\n    color: $white-color;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 14px;\n  }\n  .mr-6 {\n    margin-right: 6.5px;\n  }\n  .edit-btn {\n    height: 40px;\n    min-width: 71px !important;\n    border: 1px solid $grey-color !important;\n    border-radius: 8px !important;\n    background-color: $white-color !important;\n    color: $label-color;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 15px !important;\n    letter-spacing: 0;\n    line-height: 14px;\n    text-transform: capitalize !important;\n    text-align: center;\n    padding-left: 16px !important;\n    padding-right: 14px !important;\n  }\n  .add-btn {\n    height: 40px;\n    min-width: 70px !important;\n    border: 1px solid $blue-color !important;\n    border-radius: 8px !important;\n    background-color: $blue-color !important;\n    color: $white-color;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 15px !important;\n    letter-spacing: 0;\n    line-height: 14px;\n    text-transform: capitalize !important;\n    text-align: center;\n    padding-left: 16px !important;\n    padding-right: 14px !important;\n  }\n  td {\n    padding: 0px;\n    color: $label-color !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 14px;\n    transition: 0.5s;\n    min-height: 60px;\n    border-right: 1px solid #d8d8d8;\n  }\n  .normal-box {\n    min-height: 60px;\n    padding: 11px 15px;\n    background-color: #ffffff;\n    position: relative;\n    display: inline-flex;\n    width: 100%;\n    height: 100%;\n    border-bottom: 1px solid #d8d8d8;\n    &.red-bg {\n      background-color: #ffdddd !important;\n    }\n    &.blue-bg {\n      background-color: #e6efff !important;\n    }\n    &.green-bg{\n      background-color: #edffee !important;\n    }\n    .redbar {\n      width: 5px;\n      background-color: #a70d0d;\n      position: absolute;\n      left: 0;\n      top: 0px;\n      bottom: 0px;\n    }\n    .bluebar {\n      width: 5px;\n      background-color: #344A5C;\n      position: absolute;\n      left: 0;\n      top: 0px;\n      bottom: 0px;\n    }\n    .greenbar {\n      width: 5px;\n      background-color: #c3d34f;\n      position: absolute;\n      left: 0;\n      top: 0px;\n      bottom: 0px;\n    }\n    .count {\n      font-size: 14px;\n      font-family: TwCenMTStd-SemiBold !important;\n      color: $grey-color;\n      margin-right: 13px !important;\n    }\n    .ename {\n      font-size: 15px;\n      font-family: TwCenMTStd-Bold !important;\n      color: $label-color;\n      line-height: 18px;\n      // word-break: break-word;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 6vw;\n      cursor: pointer;\n      // margin-bottom: 7px !important;\n    }\n    .edep {\n      font-size: 12px;\n      color: $grey-color;\n    }\n    .eval {\n      font-size: 20px;\n      font-family: TwCenMTStd-Bold !important;\n      color: $label-color;\n    }\n  }\n  td:last-child {\n    border-right: unset !important;\n  }\n  tr {\n    transition: 0.5s;\n    background: #f8f8fa;\n    &:hover {\n      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n    }\n  }\n  .company-name {\n    color: $label-color !important;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 14px;\n    max-width: 280px;\n  }\n}\n.text-right {\n  text-align: right;\n}\n.sidebar-footer,\n.admin-sidebar-footer {\n  width: 100%;\n  .MuiButtonBase-root {\n    margin: unset !important;\n    border-radius: unset !important;\n    min-height: 48px;\n    padding-left: 18px !important;\n    padding-right: 10px !important;\n    .MuiListItemIcon-root {\n      margin-right: 9px;\n    }\n    .MuiListItemText-primary {\n      color: $white-color;\n      font-family: TwCenMTStd-SemiBold !important;\n      line-height: 16px !important;\n      font-size: 18px !important;\n    }\n  }\n}\n.MuiToolbar-root {\n  padding-left: 0px !important;\n}\n.inner-network {\n  position: relative;\n  height: auto;\n}\n.full-screen {\n  height: 100%;\n}\n// .MuiAppBar-root {\n//   z-index: 1200 !important;\n// }\n.pb-24 {\n  padding-bottom: 24px;\n}\n.org-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 230px);\n  overflow: auto;\n  padding: 24px;\n  .org-parent {\n    // width: 300px;\n    // height: 300px;\n    // border: 1px solid red;\n    // position: relative;\n    // top: 23vh;\n    .org-category-child {\n      width: 120px;\n      height: 70px;\n      flex-wrap: nowrap;\n      // border: 1px solid red;\n      .org-category-box {\n        height: 70px;\n        width: 70px;\n        background-color: #cccdd2;\n        border-radius: 50%;\n        color: $white-color;\n        font-family: TwCenMTStd-SemiBold !important;\n        font-size: 25px;\n        letter-spacing: 0;\n        line-height: 23px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &.child-active {\n          background-color: rgba(198, 12, 104, 0.5);\n        }\n        position: relative;\n        .more-child {\n          width: 14px;\n          height: 14px;\n          background-color: $grey-color;\n          border-radius: 50%;\n          color: $white-color;\n          font-size: 10px;\n          font-family: TwCenMTStd-Bold !important;\n          position: absolute;\n          cursor: pointer;\n          right: -6px;\n        }\n        .letter {\n          color: $white-color;\n          font-family: TwCenMTStd-SemiBold !important;\n          font-size: 25px;\n          letter-spacing: 0;\n          line-height: 23px;\n          text-transform: uppercase;\n        }\n      }\n      .sub-child-box {\n        // width: 200px;\n        // height: 100px;\n        position: absolute;\n        right: 0px;\n        top: 0px;\n      }\n      .org-category-box-child {\n        height: 60px;\n        width: 60px;\n        background-color: #cccdd2;\n        border-radius: 50%;\n        color: $white-color;\n        font-family: TwCenMTStd-SemiBold !important;\n        font-size: 22px;\n        letter-spacing: 0;\n        line-height: 23px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &.child-active {\n          background-color: rgba(198, 12, 104, 0.5);\n        }\n        position: relative;\n        .more-child {\n          width: 14px;\n          height: 14px;\n          background-color: $grey-color;\n          border-radius: 50%;\n          color: $white-color;\n          font-size: 10px;\n          font-family: TwCenMTStd-Bold !important;\n          position: absolute;\n          cursor: pointer;\n          right: -6px;\n        }\n        .letter {\n          color: $white-color;\n          font-family: TwCenMTStd-SemiBold !important;\n          font-size: 22px;\n          letter-spacing: 0;\n          line-height: 23px;\n          text-transform: uppercase;\n        }\n      }\n      .org-category-box-subchild {\n        height: 50px;\n        width: 50px;\n        background-color: #cccdd2;\n        border-radius: 50%;\n        color: $white-color;\n        font-family: TwCenMTStd-SemiBold !important;\n        font-size: 18px;\n        letter-spacing: 0;\n        line-height: 23px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &.child-active {\n          background-color: rgba(198, 12, 104, 0.5);\n        }\n        position: relative;\n        .more-child {\n          width: 14px;\n          height: 14px;\n          background-color: $grey-color;\n          border-radius: 50%;\n          color: $white-color;\n          font-size: 10px;\n          font-family: TwCenMTStd-Bold !important;\n          position: absolute;\n          cursor: pointer;\n          right: -6px;\n        }\n        .letter {\n          color: $white-color;\n          font-family: TwCenMTStd-SemiBold !important;\n          font-size: 18px;\n          letter-spacing: 0;\n          line-height: 23px;\n          text-transform: uppercase;\n        }\n      }\n      .line {\n        height: 1px;\n        background-color: $label-color;\n        flex: 1;\n        position: relative;\n        .circle {\n          position: absolute;\n          right: 0;\n          width: 10px;\n          background-color: $label-color;\n          height: 10px;\n          border-radius: 50%;\n          top: -5px;\n        }\n      }\n    }\n    .one {\n      position: absolute;\n      transform: rotate(-70deg);\n      top: 5px;\n      left: 130px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(70deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .two {\n      position: absolute;\n      transform: rotate(-25deg);\n      top: 65px;\n      left: 188px;\n      width: 153px !important;\n      .letter,\n      .more-child {\n        transform: rotate(25deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .three {\n      position: absolute;\n      transform: rotate(14deg);\n      top: 147px;\n      left: 195px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(-14deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .four {\n      position: absolute;\n      transform: rotate(69deg);\n      top: 229px;\n      left: 120px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(-70deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .five {\n      position: absolute;\n      transform: rotate(-236deg);\n      top: 218px;\n      left: 15px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(236deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .six {\n      position: absolute;\n      transform: rotate(-200deg);\n      top: 152px;\n      left: -40px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(200deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .seven {\n      position: absolute;\n      transform: rotate(-161deg);\n      top: 77px;\n      left: -41px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(161deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .eight {\n      position: absolute;\n      transform: rotate(-120deg);\n      top: 6px;\n      left: 21px;\n      width: 146px !important;\n      .letter,\n      .more-child {\n        transform: rotate(120deg);\n      }\n      .sub-child-main {\n        position: absolute;\n        right: -126px;\n        transform: rotate(0deg);\n      }\n      .sub-last-child-main {\n        position: absolute;\n        left: 132px;\n        &.last-one {\n          transform: rotate(0deg);\n        }\n        &.last-two {\n          top: -35px;\n          left: 119px !important;\n          transform: rotate(-35deg);\n          .letter,\n          .more-child {\n            transform: rotate(-126deg);\n          }\n        }\n        &.last-three {\n          top: -57px;\n          left: 90px !important;\n          transform: rotate(-70deg);\n          .letter,\n          .more-child {\n            transform: rotate(-90deg);\n          }\n        }\n        &.last-four {\n          top: 39px;\n          left: 119px !important;\n          transform: rotate(39deg);\n          .letter,\n          .more-child {\n            transform: rotate(160deg);\n          }\n        }\n        &.last-five {\n          top: -60px;\n          left: 52px !important;\n          transform: rotate(-106deg);\n          .letter,\n          .more-child {\n            transform: rotate(-55deg);\n          }\n        }\n      }\n    }\n    .org-main {\n      height: 100px;\n      width: 100px;\n      background-color: #cccdd2;\n      border-radius: 50%;\n      color: $white-color;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 25px;\n      letter-spacing: 0;\n      line-height: 23px;\n      text-transform: uppercase;\n      position: relative;\n      left: 100px;\n      top: 100px;\n    }\n  }\n}\n.MuiList-root {\n  .sideBarActive {\n    background-color: rgb(195, 211, 79, 0.15) !important;\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      min-height: 48px;\n      width: 8px;\n      background-color: $theme-coclor;\n    }\n  }\n}\n// .sideBarActive:hover {\n//   background-color: $theme-coclor !important;\n// }\n.sidebarLink {\n  text-decoration: none !important;\n  color: unset !important;\n  .MuiButtonBase-root {\n    margin: unset !important;\n    border-radius: unset !important;\n    min-height: 48px;\n    padding-left: 18px !important;\n    padding-right: 10px !important;\n    .MuiListItemIcon-root {\n      margin-right: 9px;\n    }\n    .MuiListItemText-primary {\n      color: $white-color;\n      font-family: TwCenMTStd-SemiBold !important;\n      line-height: 16px !important;\n      font-size: 18px !important;\n    }\n  }\n}\n.contant-bgcolor {\n  background: #f8f8fa;\n}\n.linkHide {\n  text-decoration: none !important;\n  color: unset !important;\n}\n.hr-text {\n  color: #000000 !important;\n  font-size: 12px !important;\n  letter-spacing: 0;\n  line-height: 11px;\n  .s-dot {\n    width: 12px;\n    height: 12px;\n    margin-right: 4px;\n  }\n}\n.d-flex-a {\n  display: flex;\n  align-items: center;\n}\n.flex-column {\n  flex-direction: column;\n}\n.d-flex-j {\n  display: flex;\n  justify-content: center;\n}\n.d-felx-je{\n  display: flex;\n  justify-content: space-evenly;\n}\n.d-flex {\n  display: flex;\n}\n.flex-sb {\n  justify-content: space-between;\n}\n.flex-end {\n  justify-content: flex-end;\n}\n.flex-1 {\n  flex: 1;\n}\n.mb-7 {\n  margin-bottom: 7px !important;\n}\n.mb-8 {\n  margin-bottom: 8px !important;\n}\n.mt-20 {\n  margin-top: 20px !important;\n}\n.mb-30 {\n  margin-bottom: 30px !important;\n}\n.mt-25 {\n  margin-top: 25px !important;\n}\n.mb-15 {\n  margin-bottom: 15px !important;\n}\n.mb-12 {\n  margin-bottom: 12px !important;\n}\n.mt-15 {\n  margin-top: 15px !important;\n}\n.pt-15 {\n  padding-top: 15px;\n}\n.select-arrow {\n  fill: $label-color;\n}\n.d-flex-ja {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login-banner {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .login-box {\n    min-height: 344px;\n    width: 414px;\n    border-radius: 8px;\n    background-color: #ffffff;\n    box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.22);\n    padding: 0px 30px 21px 30px;\n  }\n  .info-text {\n    color: $label-color;\n    font-size: 18px;\n    letter-spacing: 0;\n    line-height: 15px;\n  }\n  .otp-text {\n    color: $label-color;\n    font-size: 14px;\n    letter-spacing: 0;\n    line-height: 15px;\n  }\n  .link-text {\n    color: #979598;\n    font-size: 15px;\n    letter-spacing: 0;\n    line-height: 14px;\n    margin-top: 14px;\n  }\n  .back-btn {\n    color: $blue-color;\n    text-decoration: underline solid $blue-color;\n    font-family: TwCenMTStd-SemiBold !important;\n    font-size: 16px;\n    letter-spacing: 0;\n    text-transform: capitalize !important;\n    line-height: 14px;\n    margin-top: 36px;\n    margin-bottom: 8px;\n    &:hover {\n      text-decoration: underline solid $blue-color;\n    }\n  }\n  .logo-text {\n    font-size: 40px;\n    margin-top: 50px;\n    margin-bottom: 43px;\n    color: $blue-color;\n    text-align: center;\n    justify-content: center;\n    font-family: TwCenMTStd-Bold !important;\n    p {\n      font-size: 40px;\n      color: $theme-coclor;\n      font-family: TwCenMTStd-Bold !important;\n      &::first-letter {\n        letter-spacing: -10px;\n      }\n    }\n  }\n  .forgot-pass-description {\n    font-size: 15px !important;\n    color: $grey-color !important;\n    font-family: TwCenMTStd-Regular !important;\n    padding-bottom: 10px !important;\n  }\n  .forgot-pass-heading {\n    font-size: 18px !important;\n    font-family: TwCenMTStd-Regular !important;\n    color: $label-color !important;\n  }\n  .custom-field {\n    p {\n      color: $label-color !important;\n      font-size: 12px !important;\n      letter-spacing: 0;\n      line-height: 24px;\n      font-family: TwCenMTStd-SemiMedium !important;\n    }\n    .forgot-password {\n      color: $red-link-color !important;\n      font-size: 12px !important;\n      letter-spacing: 0;\n      line-height: 24px;\n      cursor: pointer !important;\n      text-decoration: underline !important;\n      font-family: TwCenMTStd-SemiMedium !important;\n    }\n    .MuiFormHelperText-root {\n      color: #d32f2f !important;\n    }\n    .custom-input {\n      width: 100%;\n      .MuiInputBase-root {\n        height: 43px;\n        border-radius: 7px;\n        background-color: #f8f8fa;\n        &::before,\n        &::after {\n          border-bottom: unset;\n        }\n      }\n      .MuiInputBase-input {\n        padding: 13px 11px;\n        font-size: 15px !important;\n        font-family: TwCenMTStd-SemiBold !important;\n        color: $label-color;\n      }\n    }\n  }\n  .submit-btn {\n    margin-top: 20px;\n    height: 44px;\n    width: 100%;\n    border-radius: 4px;\n    color: $white-color;\n    background-color: $theme-coclor;\n    font-size: 15px !important;\n    font-family: TwCenMTStd-SemiBold !important;\n    letter-spacing: 1px !important;\n    &:hover {\n      background-color: $theme-coclor;\n    }\n  }\n  .border-box {\n    height: 1px;\n    background-color: $border-color;\n    margin: 30px 0 23px 0;\n  }\n  .copy-text {\n    color: $label-color;\n    font-size: 12px;\n    letter-spacing: 0;\n    line-height: 24px;\n    text-align: center;\n  }\n  .back-to-login {\n    color: $grey-color;\n    font-size: 14px;\n    letter-spacing: 0;\n    line-height: 24px;\n    text-align: center;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n}\n.border-bottom {\n  border-bottom: 1px solid $divider-color;\n}\n.drawer-close {\n  height: 44px;\n  width: 44px;\n  border: 4px solid #ffffff;\n  background-color: #eaeaef;\n  border-radius: 50%;\n  cursor: pointer;\n  position: fixed;\n  margin-left: -56px !important;\n  margin-top: 30px !important;\n  svg {\n    fill: $grey-color;\n  }\n}\n.px-17 {\n  padding-left: 17px;\n  padding-right: 17px;\n}\n.py-16 {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.textarea-noresize {\n  resize: none;\n}\n.header-tab {\n  color: $label-color !important;\n  font-family: TwCenMTStd-SemiBold !important;\n  font-size: 15px !important;\n  letter-spacing: 1px !important;\n  line-height: 14px !important;\n  // min-height: 80px;\n  padding: 35px 12px 30px 12px;\n  display: flex;\n  align-items: center;\n  min-width: 86px;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  &.mr-24 {\n    // margin-right: 24px;\n  }\n  &.active {\n    &::after {\n      content: '';\n      height: 5px;\n      background-color: $theme-coclor;\n      width: 100%;\n      position: absolute;\n      bottom: 0;\n    }\n    // border-bottom: 5px solid $theme-coclor;\n  }\n}\n.p-title {\n  color: $label-color !important;\n  font-family: TwCenMTStd-SemiBold !important;\n  font-size: 24px !important;\n  letter-spacing: 0px !important;\n  line-height: 21px !important;\n}\n.profile-modal {\n  .MuiBox-root {\n    &:focus-visible {\n      border: none;\n      outline: none;\n    }\n\n    .labels {\n      color: $label-color !important;\n      font-family: TwCenMTStd-SemiMedium !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n      margin-bottom: 20px !important;\n    }\n    .client-labels {\n      color: $label-color !important;\n      font-family: TwCenMTStd-SemiMedium !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n      margin-bottom: 5px !important;\n    }\n    .details {\n      color: $label-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n      // word-break: break-all;\n      margin-bottom: 20px !important;\n      margin-right: 25px;\n    }\n    .clientpop-details {\n      color: $label-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 15px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n      // word-break: break-all;\n      margin-bottom: 5px !important;\n      margin-right: 25px;\n    }\n    .close-text {\n      color: $blue-color !important;\n      text-decoration: underline solid $blue-color;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n      cursor: pointer;\n    }\n  }\n}\n.set-parent {\n  min-height: calc(100vh - 80px);\n  .set-child {\n    min-height: 237px;\n    margin-top: -80px !important;\n    width: 500px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);\n    .px-24 {\n      padding: 0 24px;\n    }\n    .sett-box {\n      min-height: 63px;\n      border-bottom: 1px solid $divider-color;\n      svg {\n        cursor: pointer;\n        fill: $label-color;\n        font-size: 16px;\n      }\n    }\n  }\n}\n.n-btn {\n  color: $label-color !important;\n  font-size: 14px !important;\n  letter-spacing: 1px !important;\n  line-height: 14px !important;\n  font-family: TwCenMTStd-SemiBold !important;\n  text-decoration: underline solid $label-color !important;\n}\n.save-btn {\n  height: 48px;\n  min-width: 124px !important;\n  border-radius: 4px !important;\n  background-color: $save-color !important;\n  color: $white-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 15px !important;\n  letter-spacing: 0.94px !important;\n  line-height: 14px !important;\n}\n.cancel-btn {\n  height: 48px;\n  min-width: 124px !important;\n  border-radius: 4px !important;\n  background-color: $grey-color !important;\n  color: $white-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 15px !important;\n  letter-spacing: 0.94px !important;\n  line-height: 14px !important;\n}\n.role-sidebox {\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n  .role-italic {\n    color: $save-color !important;\n    font-family: TwCenMTStd-Italic !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 20px !important;\n  }\n  .role-item {\n    cursor: pointer !important;\n    min-height: 64px;\n    background-color: rgb(255, 255, 255, 0.13);\n    color: $grey-color !important;\n    font-family: TwCenMTStd-SemiBold !important;\n    font-size: 18px !important;\n    letter-spacing: 0;\n    line-height: 16px !important;\n    padding: 0 24px;\n    display: flex;\n    align-items: center;\n    &.role-acitive {\n      background-color: rgb(0, 97, 255, 0.13) !important;\n      color: $label-color !important;\n    }\n    .div {\n      color: $grey-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      letter-spacing: 0;\n      line-height: 16px !important;\n    }\n  }\n}\n.role-contentbox {\n  padding: 30px;\n  .permission-box {\n    min-height: 330px;\n    border-radius: 10px !important;\n    background-color: #ffffff;\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);\n    padding: 36px 48px;\n    .per-title {\n      color: $label-color !important;\n      font-size: 24px !important;\n      letter-spacing: 0;\n      line-height: 21px !important;\n      margin-bottom: 18px;\n      padding-left: 10px;\n    }\n  }\n}\n.role-class-code-contentbox {\n  padding: 30px;\n  padding-top: 0px;\n  .permission-box {\n    min-height: 330px;\n    border-radius: 10px !important;\n    background-color: #ffffff;\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);\n    // padding: 36px 48px;\n    .per-title {\n      color: $label-color !important;\n      font-size: 24px !important;\n      letter-spacing: 0;\n      line-height: 21px !important;\n      padding: 20px 20px 20px 20px;\n      border-bottom: 1px solid #e8e8e8;\n    }\n    .class-code-div {\n      padding: 10px 20px;\n      background-color: #f7f5f9;\n      border-right: 1px solid #e8e8e8;\n      border-bottom: 1px solid #e8e8e8;\n      cursor: pointer;\n      .class-code-name {\n        color: #979598 !important;\n        font-size: 18px !important;\n        font-family: TwCenMTStd-Regular !important;\n        letter-spacing: 0;\n      }\n      .class-code-count {\n        color: #979598 !important;\n        font-size: 12px !important;\n        font-family: TwCenMTStd-SemiBold !important;\n        letter-spacing: 0;\n      }\n    }\n    .active {\n      border-left: 5px solid #0061ff;\n      background-color: $white-color;\n      .class-code-name {\n        color: #171a33 !important;\n        font-family: TwCenMTStd-Bold !important;\n      }\n      .class-code-count {\n        color: #0061ff !important;\n      }\n    }\n    .input-field {\n      width: 100% !important;\n      .MuiInput-underline {\n        padding-bottom: 8px !important;\n      }\n      .MuiInput-underline::before {\n        border-bottom: 1px solid #e8e8e8 !important;\n      }\n      .MuiInput-underline::after {\n        border-bottom: 1px solid #e8e8e8 !important;\n      }\n    }\n    .class-code-list-box {\n      margin-top: 15px !important;\n      .class-code-list-view {\n        align-items: center !important;\n        margin-top: 3px;\n        padding: 3px 10px;\n        border-radius: 4px;\n        cursor: pointer !important;\n        .class-code-list-text {\n          color: #171a33 !important;\n          font-size: 18px !important;\n          font-family: TwCenMTStd-Regular !important;\n          letter-spacing: 0;\n        }\n      }\n      .list-view-active {\n        background-color: #e0ecff;\n      }\n    }\n  }\n}\n.h-44 {\n  min-height: 44px;\n  p {\n    color: $label-color !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 14px !important;\n    //margin-left: 10px !important;\n  }\n}\n.normal-checkbox {\n  height: 24px;\n  width: 24px;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  background-color: #efefef;\n}\n.parent-checkbox {\n  margin-left: unset !important;\n}\n.ml-40 {\n  margin-left: 40px !important;\n}\n.ml-10 {\n  margin-left: 10px !important;\n}\n.ml-20 {\n  margin-left: 20px !important;\n}\n.ml-8 {\n  margin-left: 8px !important;\n}\n.custom-checkbox {\n  .MuiCheckbox-root {\n    &.Mui-checked {\n      color: $save-color !important;\n    }\n  }\n  span {\n    color: $label-color !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 14px !important;\n  }\n}\n.h-161 {\n  min-height: calc(100vh - 161px);\n}\n.modal-gmail {\n  color: $label-color !important;\n  font-size: 15px !important;\n  letter-spacing: 0;\n  line-height: 14px !important;\n  margin-top: 7px !important;\n  word-break: break-all;\n}\n.modal-name {\n  color: $label-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 16px !important;\n  letter-spacing: 0;\n  line-height: 14px !important;\n  word-break: break-all;\n}\n.add-photo {\n  color: $blue-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 14px !important;\n  letter-spacing: 0;\n  line-height: 13px !important;\n  text-decoration: underline solid $blue-color;\n  cursor: pointer;\n  margin-top: 6px !important;\n}\n.text-center {\n  text-align: center;\n}\n.flex-1 {\n  flex: 1;\n}\n.pl-32 {\n  padding-left: 32px !important;\n}\n.pt-10 {\n  padding-top: 10px !important;\n}\n.pop-default {\n  height: 50px;\n  width: 50px;\n  background-color: $blue-color;\n  color: $white-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 24px !important;\n  border-radius: 50%;\n  letter-spacing: 0;\n  line-height: 22px;\n}\n.pop-default2 {\n  height: 50px;\n  width: 50px;\n  color: $white-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 24px !important;\n  border-radius: 50%;\n  letter-spacing: 0;\n  line-height: 22px;\n}\n.profile-default {\n  height: 100px;\n  width: 100px;\n  background-color: $blue-color;\n  color: $white-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 24px !important;\n  border-radius: 50%;\n  letter-spacing: 0;\n  line-height: 22px;\n}\n.pl-8 {\n  padding-left: 8px;\n}\n.mt-10 {\n  margin-top: 10px !important;\n}\n.mt-30 {\n  margin-top: 30px !important;\n}\n.px-87 {\n  padding-left: 87px;\n  padding-right: 87px;\n}\n.warn-text {\n  margin-top: 4px;\n  color: $red-color !important;\n  font-size: 12px !important;\n  font-style: italic;\n  letter-spacing: 0;\n  line-height: 11px !important;\n}\n.warn-text-15 {\n  margin-top: 30px !important;\n  padding-left: 10px;\n  color: $red-color !important;\n  font-family: TwCenMTStd-Italic !important;\n  font-size: 15px !important;\n  font-style: italic;\n  letter-spacing: 0;\n  line-height: 11px !important;\n}\n.normal-text {\n  color: $label-color !important;\n  font-size: 15px !important;\n  letter-spacing: 0;\n  line-height: 14px !important;\n}\n.cinput {\n  &:checked {\n    background-color: $theme-coclor;\n  }\n}\n.custom-switch {\n  height: 31px !important;\n  width: 51px !important;\n  padding: unset !important;\n  border-radius: 30px !important;\n  margin: 0 14px 0 8px;\n  .MuiSwitch-thumb {\n    height: 28px !important;\n    width: 28px !important;\n    border: 0.5px solid rgba(0, 0, 0, 0.04) !important;\n    background-color: #ffffff !important;\n    margin-top: 1px;\n    box-shadow:\n      0 3px 8px 0 rgba(0, 0, 0, 0.15),\n      0 3px 1px 0 rgba(0, 0, 0, 0.06) !important;\n  }\n  .MuiSwitch-track {\n    background-color: $grey-color;\n  }\n  .MuiButtonBase-root.Mui-checked + .MuiSwitch-track {\n    background-color: #6fc889 !important;\n    opacity: 1 !important;\n  }\n  .MuiSwitch-switchBase {\n    padding: 0px !important;\n  }\n}\n.private-form {\n  .submit-btn {\n    margin-top: 20px;\n    height: 44px;\n    width: 100%;\n    border-radius: 4px;\n    color: $white-color;\n    background-color: $theme-coclor;\n    font-size: 15px !important;\n    font-family: TwCenMTStd-SemiBold !important;\n    letter-spacing: 1px !important;\n    &:hover {\n      background-color: $theme-coclor;\n    }\n  }\n\n  .custom-field {\n    p {\n      color: $label-color !important;\n      font-size: 12px !important;\n      letter-spacing: 0;\n      line-height: 24px;\n      font-family: TwCenMTStd-SemiMedium !important;\n    }\n    .MuiFormHelperText-root {\n      color: #d32f2f !important;\n    }\n    margin-bottom: 8px;\n    .custom-input {\n      width: 100%;\n      .MuiOutlinedInput-notchedOutline {\n        border: unset !important;\n      }\n      .MuiInputBase-root {\n        height: 43px !important;\n        border-radius: 7px !important;\n        background-color: #f8f8fa;\n        &::before,\n        &::after {\n          border-bottom: unset;\n        }\n      }\n      .MuiInputBase-input {\n        padding: 13px 11px;\n        font-size: 15px !important;\n        font-family: TwCenMTStd-SemiBold !important;\n        color: $label-color;\n        &::placeholder {\n          font-family: TwCenMTStd-Medium !important;\n        }\n      }\n    }\n    .custom-big-input {\n      width: 100%;\n      .MuiOutlinedInput-notchedOutline {\n        border: unset !important;\n      }\n      .MuiInputBase-root {\n        height: 48px !important;\n        border-radius: 7px !important;\n        background-color: #f8f8fa;\n        &::before,\n        &::after {\n          border-bottom: unset;\n        }\n      }\n      .MuiInputBase-input {\n        padding: 13px 11px;\n        font-size: 15px !important;\n        font-family: TwCenMTStd-SemiBold !important;\n        color: $label-color;\n      }\n    }\n  }\n}\n.modal-yes-btn {\n  height: 44px;\n  width: 100%;\n  border-radius: 4px;\n  color: $white-color !important;\n  background-color: $red-color !important;\n  font-size: 15px !important;\n  font-family: TwCenMTStd-Bold !important;\n  letter-spacing: 1px !important;\n  &:hover {\n    background-color: $red-color;\n  }\n  &:disabled{\n    background-color:$red-color-disabled\n  }\n}\n.modal-yes1-btn {\n  height: 44px;\n  width: 100%;\n  border-radius: 4px;\n  color: $white-color !important;\n  background-color: $theme-coclor !important;\n  font-size: 15px !important;\n  font-family: TwCenMTStd-Bold !important;\n  letter-spacing: 1px !important;\n  &:hover {\n    background-color: $theme-coclor;\n  }\n  &:disabled{\n    background-color: $theme-coclor-disabled\n  }\n}\n.modal-no-btn {\n  height: 44px;\n  width: 100%;\n  border-radius: 4px;\n  color: $white-color !important;\n  background-color: $grey-color !important;\n  font-size: 15px !important;\n  font-family: TwCenMTStd-Bold !important;\n  letter-spacing: 1px !important;\n  &:hover {\n    background-color: $grey-color;\n  }\n}\n.modal-title {\n  color: $label-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 18px !important;\n  letter-spacing: 1.2px !important;\n  line-height: 16px !important;\n  text-transform: uppercase;\n}\n.modal-dis {\n  color: $grey-color !important;\n  font-size: 18px !important;\n  letter-spacing: 0;\n  line-height: 20px !important;\n  margin-top: 6px !important;\n  margin-bottom: 10px !important;\n}\n.closesvg {\n  fill: $grey-color !important;\n  cursor: pointer;\n}\n.role-title {\n  color: $pop-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  font-size: 20px !important;\n  letter-spacing: 0;\n  line-height: 18px !important;\n}\n.tool-add-btn {\n  height: 48px;\n  width: 171px;\n  border-radius: 4px;\n  background-color: $theme-coclor !important;\n  font-size: 15px !important;\n  letter-spacing: 0.94px !important;\n  line-height: 14px;\n  color: $white-color !important;\n  font-family: TwCenMTStd-Bold !important;\n  margin-left: 25px !important;\n  cursor: pointer;\n}\n.custom-toolbar {\n  justify-content: space-between;\n\n  .page-title {\n    color: $label-color !important;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 24px !important;\n    letter-spacing: 0;\n    line-height: 22px !important;\n    padding-left: 30px;\n  }\n  .backlabel {\n    color: $label-color !important;\n    font-family: TwCenMTStd-SemiBold !important;\n    font-size: 15px !important;\n    letter-spacing: 0;\n    line-height: 14px;\n  }\n  .backicon {\n    fill: $label-color;\n    font-size: 16px !important;\n  }\n  .vborder {\n    height: 40px;\n    width: 2px;\n    background-color: #d8d8d8;\n    margin: 0 20.5px;\n  }\n}\n.norecord {\n  height: 400px;\n}\n.deactive-row {\n  &:hover {\n    background: #fff0f0 !important;\n  }\n}\n.active-row {\n  &:hover {\n    background: #edffee !important;\n  }\n}\n.inited-row {\n  &:hover {\n    background: #f2f2ff !important;\n  }\n}\n.pl-20 {\n  padding-left: 20px;\n}\n.pointer {\n  cursor: pointer;\n}\n.profile-item {\n  padding: 4px 16px 12px 16px !important;\n  border-bottom: 1px solid rgba(177, 180, 190, 0.22);\n  margin-bottom: 20px;\n  .MuiAvatar-root {\n    background-color: $blue-color;\n  }\n  .MuiListItemAvatar-root {\n    min-width: 40px !important;\n  }\n  .MuiListItemText-root {\n    margin: unset !important;\n    padding-left: 8px;\n    span {\n      color: $grey-color !important;\n      font-size: 15px !important;\n      font-family: TwCenMTStd-Medium !important;\n      line-height: 14px !important;\n      white-space: normal !important;\n    }\n    p:first-child {\n      color: $white-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      line-height: 17px !important;\n      margin-top: 3px;\n      white-space: normal !important;\n    }\n    p:last-child {\n      color: $grey-color !important;\n      font-family: TwCenMTStd-Medium !important;\n      font-size: 16px !important;\n      line-height: 17px !important;\n      margin-top: 5px !important;\n      white-space: normal !important;\n    }\n  }\n}\n.headerlogo-text {\n  font-size: 38px !important;\n  color: $white-color;\n  text-align: center;\n  justify-content: center;\n  font-family: TwCenMTStd-Bold !important;\n  padding-top: 5px;\n}\n.hr {\n  font-size: 38px !important;\n  color: $theme-coclor;\n  font-family: TwCenMTStd-Bold !important;\n  &::first-letter {\n    letter-spacing: -10px;\n  }\n}\n.collapse-btn {\n  height: 40px;\n  width: 40px;\n  background-color: $theme-coclor !important;\n  border-radius: 50% !important;\n  z-index: 100;\n  &:hover {\n    background-color: $theme-coclor !important;\n  }\n}\n.piec {\n  .recharts-legend-wrapper {\n    min-width: calc(100vw - 85vw);\n    max-width: 250px !important;\n  }\n}\n.turnoverChart {\n  .recharts-legend-wrapper {\n    top: 10px !important;\n    right: 0px !important;\n    min-width: calc(100vw - 85vw);\n    max-width: 350px !important;\n  }\n}\ng:focus,\npath:focus {\n  outline: none !important;\n}\n.pieo {\n  .recharts-legend-wrapper {\n    min-width: calc(100vw - 80vw);\n    max-width: 260px !important;\n  }\n  .ename {\n    max-width: 10vw !important;\n  }\n  .hrchart {\n    .recharts-legend-wrapper {\n      top: -45px !important;\n      width: auto !important;\n      right: 56px !important;\n      min-width: unset !important;\n    }\n  }\n}\n@media (min-width: 1600px) {\n  .hrchart {\n    .recharts-legend-wrapper {\n      top: -45px !important;\n      width: auto !important;\n      right: 56px !important;\n      min-width: unset !important;\n    }\n  }\n}\n\n\n.dashboard-box {\n  padding: 25px;  \n  .pie-box-summary {\n    border-radius: 10px;\n    padding: 18px 20px 15px 20px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n    padding: 0px;\n    margin-bottom: 20px;\n    margin-top:10px;\n    position: relative;\n    .datagrid-container{\n      justify-content: center;\n      align-items: center;\n      display:flex;  \n      width:100%;   \n      align-items: center;\n      align-content: center;\n      .MuiDataGrid-root{\n        --DataGrid-rowBorderColor: '#ffffff' !important\n      }    \n    }  \n    .datagrid{\n      display:flex;  \n      width:100%; \n      font-size: 17px !important;  \n      margin-bottom:20px;\n      border-radius: 10px; \n    }    \n    .datagrid-outside    {\n      width:100%;\n    }  \n  }\n  .pie-box {\n    min-height: 300px;\n    border-radius: 10px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n    padding: 18px 20px 15px 20px;\n    margin-bottom: 20px;\n    position: relative;\n    .recharts-wrapper {\n      // margin-top: 20px;\n      width: 100% !important;\n      // height: auto !important;\n    }\n    .recharts-legend-wrapper {\n      left: unset !important;\n      right: 0;\n      top: 0;\n    }\n    .total-pie {\n      color: #241a2e !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 40px !important;\n      letter-spacing: 0;\n      line-height: 38px !important;\n    }\n    .total-pie-extra-text {\n      font-size: 30px !important;\n    }\n    .ave-pie {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-Regular !important;\n      font-size: 18px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n    }\n    .legend-ul {\n      list-style-type: none !important;\n      padding-left: unset !important;\n      margin-top: 28px;\n    }\n    .legend-dot {\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      margin-right: 13px;\n      margin-left: 13px;\n      margin-top: 2px;\n    }\n    .leg-info {\n      color: #241a2e !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 17px !important;\n      line-height: 23px !important;\n      margin-bottom: 15px !important;\n      padding-right: 12px;\n    }\n    .num-info {\n      color: #241a2e !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 17px !important;\n      line-height: 23px !important;\n      margin-bottom: 15px !important;\n      margin-top: -5px !important;\n    }\n    .app-info {\n      color: $grey-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      line-height: 23px !important;\n    }\n    .app-title {\n      color: $label-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      line-height: 23px !important;\n    }\n    .vp-title {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 20px !important;\n      letter-spacing: 0;\n      line-height: 18px;\n      margin-bottom: 25px !important;\n    }\n    .down-box {\n      height: 40px;\n      width: 40px;\n      border: 1px solid #d9d9d9;\n      border-radius: 4px;\n      position: absolute;\n      right: 20px;\n      top: 18px;\n      cursor: pointer;\n    }\n    .c-title {\n      color: #171a33 !important;\n      font-size: 24px !important;\n      letter-spacing: 0;\n      line-height: 21px !important;\n      margin-top: 12px;\n    }\n\n    .info-im {\n      cursor: pointer;\n      margin-left: 5px;\n    }\n    .datagrid-container{\n      justify-content: center;\n      align-items: center;\n      display:flex;  \n      width:100%;   \n      align-items: center;\n      align-content: center;\n      .MuiDataGrid-root{\n        --DataGrid-rowBorderColor: '#ffffff' !important\n      }    \n    }  \n    .datagrid{\n      display:flex;  \n      margin-top:35px;\n      width:100%; \n      font-size: 17px !important;  \n      \n    }    \n    .datagrid-outside    {\n      width:100%;\n    }  \n  }\n}\n\n.super-app-theme-header{\n  font-size: 17px !important;\n  font-weight: bolder !important;\n  height:15px;\n  color: $blue-color;\n  background-color: $white-color;\n  border:none;\n  align-items: center;\n  align-content: center;\n  .MuiDataGrid-columnHeaderTitle { font-weight: bold !important; }\n}\n\n.super-app-theme-cell{\n  font-size: 17px !important;\n  height:15px;\n  color:$blue-color;\n  background-color: $white-color;\n  border:none;\n  align-items: center;\n  align-content: center;\n}\n\n.employee-status-header{\n  background-color: #36485A;\n  color:#FFFFFF;\n}\n\n.needs-attention-text{\n  border-radius: 10px;\n  border: 1px solid #F8E4E6;\n  background-color: #F8E4E6;\n  color: #DF1717;\n  width:150px;\n  text-align: center;\n}\n\n.on-the-move-text{\n  border-radius: 10px;\n  border: 1px solid #E0F3DF;\n  background-color: #E0F3DF;\n  color: #04C30A;\n  width:150px;\n  text-align: center;\n}\n\n.good-standing-text{\n  border-radius: 10px;\n  border: 1px solid #ddddf5;\n  background-color: #ddddf5;\n  color: $blue-color;\n  width:150px;\n  text-align: center;\n}\n\n.ov-box {\n  padding: 30px 30px 30px 45px;\n  .menu-box {\n    min-height: 50px;\n    width:100%;\n    border-radius: 10px;\n    background-color: #ffffff;\n    text-align: right;\n    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n    padding: 18px 20px 15px 20px;\n    margin-bottom: 20px;\n    position: relative;\n    .blank-space{\n      float:left;\n      width:90%;\n    }\n    .containter-control{\n      float:right;\n    }\n  }\n  .category-status-container-normal-border{\n    border: 1px solid #d6d6d6;\n    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n  }\n  .category-status-container-highlight-border{\n    border: 1px solid #c22c2c;\n    box-shadow: 0 4px 10px 0 #c22c2c;\n  }\n  .category-status-container{\n    border-radius: 10px;\n    height: 144px;\n    background-color: #ffffff;    \n    padding: 18px 16px;\n    margin-bottom: 20px;\n    position: relative;\n    .down-box-plus {\n      padding-left:5px;\n      height: 20px;\n      width: 60px;\n      border: 1px solid #E0F3DF;\n      border-radius: 10px;\n      background-color: #E0F3DF;\n      color: #04C30A;\n      font-size: 12px;\n      font-weight:bold;\n      text-align: right;   \n      margin-top:3px;       \n    }\n    .img-icon-container{\n       margin-bottom:10px;\n      .img-icon{\n        height:14px;\n        width:14px;\n        object-fit: fill;\n        padding-bottom:2px;\n      }\n    }    \n\n    .down-box-minus {\n      padding-left:5px;\n      height: 20px;\n      width: 60px;\n      border: 1px solid #F8E4E6;\n      border-radius: 10px;\n      background-color: #F8E4E6;\n      color: #DF1717;\n      font-size: 12px;\n      font-weight:bold;\n      text-align: right;\n      margin-top:3px;  \n      float:right;  \n    }\n    .image-container{\n      padding-top: 10px;\n      text-align: right;\n      vertical-align: middle;\n      width:100%;\n     .image-graph{\n        width:110px;\n        object-fit: fill;\n      }\n    }\n    .c-title {\n      color: #5E5E60 !important;\n      font-size: 20px !important;\n      letter-spacing: 0;\n      line-height: 15px !important;\n      margin-top: 10px;\n    }\n    .total-title{\n      font-size: 36px !important;\n      font-weight: bold;\n      padding-top: 5px;\n    }\n    .footer-container{\n      font-size: 10px;\n      color: #838383 !important;\n      margin-top:10px;\n      width:100%;\n    }\n  }\n  .pie-box {\n    min-height: 300px;\n    border-radius: 10px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n    padding: 18px 20px 15px 20px;\n    margin-bottom: 20px;\n    position: relative;\n    .recharts-wrapper {\n      width: 100% !important;\n    }\n    .recharts-legend-wrapper {\n      left: unset !important;\n      right: 0;\n      top: 0;\n    }\n    .total-pie {\n      color: #241a2e !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 40px !important;\n      letter-spacing: 0;\n      line-height: 38px !important;\n    }\n    .total-pie-extra-text {\n      font-size: 30px !important;\n    }\n    .ave-pie {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-Regular !important;\n      font-size: 18px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n    }\n    .ave-pie1 {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-Regular !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n    }\n    .legend-ul {\n      list-style-type: none !important;\n      padding-left: unset !important;\n      margin-top: 28px;\n    }\n    .legend-dot {\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      margin-right: 13px;\n      margin-left: 13px;\n      margin-top: 2px;\n    }\n    .leg-info {\n      color: #241a2e !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 17px !important;\n      line-height: 23px !important;\n      margin-bottom: 15px !important;\n      padding-right: 12px;\n    }\n    .num-info {\n      color: #241a2e !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 17px !important;\n      line-height: 23px !important;\n      margin-bottom: 15px !important;\n      margin-top: -5px !important;\n    }\n    .app-info {\n      color: $grey-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      line-height: 23px !important;\n    }\n    .app-title {\n      color: $label-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 18px !important;\n      line-height: 23px !important;\n    }\n    .vp-title {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 20px !important;\n      letter-spacing: 0;\n      line-height: 18px;\n      margin-bottom: 25px !important;\n    }\n    .down-box {\n      height: 40px;\n      width: 40px;\n      border: 1px solid #d9d9d9;\n      border-radius: 4px;\n      position: absolute;\n      right: 20px;\n      top: 18px;\n      cursor: pointer;\n    }\n    .c-title {\n      color: #171a33 !important;\n      font-size: 24px !important;\n      letter-spacing: 0;\n      line-height: 21px !important;\n      margin-top: 12px;\n    }\n    .R-title {\n      color: #171a33 !important;\n      font-size: 18px !important;\n      letter-spacing: 0;\n      line-height: 21px !important;\n    }\n    .info-im {\n      cursor: pointer;\n      margin-left: 5px;\n    }\n  }\n}\n.smallside,\n.normalside {\n  overflow-x: hidden;\n  .MuiPaper-root {\n    z-index: 1000 !important;\n  }\n  .MuiDrawer-paper {\n    // position: unset !important;\n    overflow-x: hidden;\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n    &:hover {\n      overflow-x: hidden;\n      &::-webkit-scrollbar {\n        width: 5px;\n        background-color: $theme-coclor;\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        top: 0;\n        scrollbar-width: thin;\n        z-index: 100;\n      }\n      &::-webkit-scrollbar-thumb {\n        background-color: #000000; /* Set the color of the thumb */\n      }\n      &::-webkit-scrollbar-track {\n        border-radius: 5px;\n      }\n      &::-webkit-scrollbar-track-piece {\n        background: #e8e8e8;\n        border-radius: 100px;\n        cursor: pointer;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: $theme-coclor;\n        border-radius: 100px;\n        cursor: pointer;\n      }\n    }\n  }\n}\n.draw-header {\n  min-height: 80px !important;\n  padding-top: 5px;\n}\n.smallside {\n  width: 60px !important;\n  .profile-item {\n    .MuiListItemText-root {\n      display: none;\n    }\n  }\n  .MuiDrawer-paper {\n    width: 60px !important;\n  }\n  .profile-item {\n    padding-left: 10px !important;\n  }\n  .sidebarLink {\n    .MuiListItemIcon-root {\n      margin-right: unset !important;\n    }\n    .MuiButtonBase-root {\n      padding-left: 20px !important;\n    }\n  }\n}\n.set-diveder {\n  height: 1px;\n  background-color: rgba(177, 180, 190, 0.22);\n  margin: 19px 0px !important;\n  width: 100%;\n}\n.w-100 {\n  width: 100%;\n}\n.extra {\n  height: 80px;\n  background-color: $label-color;\n  width: 60px;\n  text-align: center;\n  padding: 12px 0px;\n}\n.adminextra {\n  height: 80px;\n  background-color: $admin-color;\n  width: 60px;\n  text-align: center;\n  padding: 12px 0px;\n}\n.mb-18 {\n  margin-bottom: 18px !important;\n}\n.mt-40 {\n  margin-top: 40px;\n}\n.ld-box {\n  margin-top: 30px !important;\n  .ld-count-box {\n    min-height: 144px;\n    border-radius: 10px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);\n    padding: 18px 16px;\n    .ld-count {\n      color: #171a33 !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 32px !important;\n      letter-spacing: 0;\n      line-height: 29px !important;\n    }\n    .ld-green {\n      margin-top: 8px;\n      svg {\n        fill: $theme-coclor;\n        margin-right: 7.5px;\n      }\n      color: $theme-coclor !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n    }\n    .ld-red {\n      margin-top: 8px;\n      svg {\n        fill: $red-color;\n        margin-right: 7.5px;\n      }\n      color: $red-color !important;\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px !important;\n    }\n    .black-box {\n      height: 40px;\n      width: 40px;\n      background-color: #171a33;\n      border-radius: 50%;\n      .clock {\n        fill: #ffffff;\n      }\n    }\n    .ld-c-title {\n      color: #171a33 !important;\n      font-size: 22px !important;\n      letter-spacing: 0;\n      line-height: 19px !important;\n      margin-left: 9px !important;\n    }\n  }\n}\n.dash-count {\n color: #171a33 !important;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 32px !important;\n      letter-spacing: 0;\n      line-height: 29px !important;\n}\n.zero_per{\n  fill: $theme-coclor !important;\n  font-size: 25px !important;\n  margin-left: 19.5px !important; \n}\n.up-per2{ \n    fill:  #c60c0c !important;\n    font-size: 25px !important;\n    margin-left: 19.5px !important; \n}\n.down-per2{\n  transform: rotate(180deg);\n    fill: $theme-coclor !important;\n    font-size: 25px !important;\n    margin-left: 19.5px !important;\n}\n.per-txt2 {\n    color: $grey-color;\n    font-size: 10px;\n    font-family: TwCenMTStd-Bold !important;\n    letter-spacing: 0;\n    line-height: 12px;\n    margin-left: 4px !important;\n  }\n.dash-engament-box{\n  min-height: 100px;\n    border-radius: 10px;\n    background-color: #F8F8FA;\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);\n    padding: 18px 16px;\n}\n@media (max-width: 768px) {\n  .login-box {\n    width: 75vw !important;\n  }\n  .custom-toolbar {\n    .page-title {\n      font-size: 16px !important;\n      padding-left: 12px !important;\n    }\n  }\n}\n@media (min-width: 1280px) {\n  .ld-box {\n    width: 1100px;\n  }\n  .org-total-box {\n    width: 1080px !important;\n  }\n}\n.employee-drawer {\n  .MuiPaper-root {\n    width: 580px !important;\n    border-radius: 10px 0 0 10px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1) !important;\n    padding-top: 30px !important;\n    .top-pad-box {\n      padding: 15px 40px 15px 30px;\n      border-bottom: 1px solid #e8e8e8;\n    }\n    .total-title {\n      color: $grey-color;\n      font-size: 18px;\n      font-family: TwCenMTStd-Medium !important;\n      letter-spacing: 0;\n      line-height: 21px;\n    }\n    .no-box {\n      min-height: 65px;\n      justify-content: flex-end !important;\n    }\n    .total-num {\n      color: $label-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 24px;\n      letter-spacing: 0;\n      line-height: 36px;\n    }\n    .emp-line {\n      color: $label-color;\n      font-size: 24px;\n      letter-spacing: 0;\n      line-height: 21px;\n    }\n    .line-sub {\n      color: $grey-color;\n      font-size: 15px;\n      letter-spacing: 0;\n      margin-top: 10px !important;\n      line-height: 14px;\n    }\n    .linechart-emp {\n      margin-top: 14px !important;\n    }\n    .default-pic {\n      height: 60px;\n      width: 60px;\n      background-color: $blue-color;\n      border-radius: 50%;\n      color: $white-color;\n      font-family: TwCenMTStd-Bold !important;\n      font-size: 16px !important;\n      letter-spacing: 0;\n      line-height: 14px;\n      margin-right: 11px;\n    }\n    .emp-name {\n      font-family: TwCenMTStd-SemiBold !important;\n      font-size: 24px;\n      letter-spacing: 0;\n      line-height: 23px;\n    }\n    .emp-dep {\n      color: $grey-color;\n      font-size: 16px;\n      letter-spacing: 0;\n      line-height: 14px;\n      margin-top: 9px !important;\n    }\n    .det-info {\n      color: $label-color;\n      font-size: 16px;\n      letter-spacing: 0;\n      line-height: 20px;\n    }\n    .det-detail {\n      color: $label-color;\n      font-size: 16px;\n      font-family: TwCenMTStd-Bold !important;\n      letter-spacing: 0;\n      line-height: 20px;\n      text-align: right;\n    }\n    .mt-14 {\n      margin-top: 14px !important;\n    }\n    .ml-13 {\n      margin-left: 13px !important;\n    }\n    .warn-pad-box {\n      padding: 14px 30px 16px 30px;\n      .warn-info-box {\n        height: 103px;\n        border-radius: 10px;\n        background-color: rgba(255, 169, 19, 0.2);\n        box-shadow: 0 2px 2px 0 rgba(166, 107, 4, 0.2);\n        padding: 20px 34px 17px 24px;\n\n        .notes {\n          color: $label-color;\n          font-size: 16px;\n          letter-spacing: 0;\n          line-height: 19px;\n        }\n        .info {\n          color: $label-color;\n          font-size: 15px;\n          letter-spacing: 0;\n          line-height: 14px;\n        }\n        .details {\n          color: $label-color;\n          font-size: 15px;\n          letter-spacing: 0;\n          line-height: 14px;\n          font-family: TwCenMTStd-Bold !important;\n        }\n      }\n    }\n    .eye-view {\n      height: 40px;\n      width: 40px;\n      border: 1px solid #d9d9d9;\n      border-radius: 4px;\n      cursor: pointer;\n    }\n  }\n}\n.org-view-more {\n  color: $grey-color;\n  font-size: 18px !important;\n  letter-spacing: 0;\n  line-height: 21px !important;\n  text-decoration: underline solid $grey-color;\n  font-family: TwCenMTStd-Medium !important;\n  cursor: pointer;\n}\n.total-titles {\n  color: $grey-color;\n  font-size: 18px;\n  font-family: TwCenMTStd-Medium !important;\n  letter-spacing: 0;\n  line-height: 21px;\n}\n.org-total-box {\n  width: 100%;\n  min-height: 112px;\n  border-radius: 20px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  margin-top: 12px !important;\n  .ot-box {\n    min-height: 112px;\n    border-right: 1px solid #979797;\n    padding: 0px 24px;\n  }\n  .no-box {\n    min-height: 112px;\n    padding: 0px 24px;\n  }\n  .up-per {\n    fill:  #c60c0c;\n    font-size: 18px;\n    margin-left: 2.5px !important;\n  }\n  .down-per {\n    transform: rotate(180deg);\n    fill: $theme-coclor;\n    font-size: 18px;\n    margin-left: 2.5px !important;\n  }\n  .per-txt {\n    color: $grey-color;\n    font-size: 10px;\n    font-family: TwCenMTStd-Bold !important;\n    letter-spacing: 0;\n    line-height: 12px;\n    margin-left: 4px !important;\n  }\n  .total-title {\n    color: $grey-color;\n    font-size: 18px;\n    font-family: TwCenMTStd-Medium !important;\n    letter-spacing: 0;\n    line-height: 21px;\n  }\n  .total-num {\n    color: $label-color;\n    font-family: TwCenMTStd-Bold !important;\n    font-size: 30px;\n    letter-spacing: 0;\n    line-height: 36px;\n  }\n}\n.en-selectbox-disabled__indicators {\n  display: none !important;\n}\n\n.custom-tooltip {\n  background: $white-color !important;\n  padding: 10px !important;\n  border-radius: 5px !important;\n  border: 0.3px solid black !important;\n  p {\n    color: black;\n    font-family: TwCenMTStd-SemiBold !important;\n    font-size: 16px !important;\n    letter-spacing: 0;\n    line-height: 20px !important;\n    margin: 0px !important;\n    padding: 0px !important;\n    padding: 5px !important;\n  }\n  .qns-blue {\n    color: $blue-color !important;\n  }\n  .qns-green {\n    color: $theme-coclor !important;\n  }\n  .view-green {\n    color: #c3d34f;\n  }\n  .view-dep {\n    color: #344A5C;\n  }\n  .view-org {\n    color: #c60c68;\n  }\n  .view-you {\n    color: #0da728;\n  }\n  .valountry-blue {\n    color: #5251b7 !important;\n  }\n  .in-valountry-green {\n    color: #c3d34f !important;\n  }\n  .last-valountry-blue {\n    color: #172087 !important;\n  }\n  .last-in-valountry-green {\n    color: #8f9f18 !important;\n  }\n  .last-valountry-black {\n    color: #000000 !important;\n  }\n}\n\n.rmenu {\n  z-index: 10000;\n  position: absolute;\n  background-color: #ffffff;\n  box-shadow: 10px salmon;\n  padding: 5px;\n  display: block;\n  margin: 0;\n  list-style-type: none;\n  list-style: none;\n  // left: 382px;\n  // top: 234px;\n  cursor: pointer;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n\n.portal-name {\n  color: $grey-color !important;\n  font-size: 15px !important;\n  font-family: TwCenMTStd-Medium !important;\n  line-height: 14px !important;\n  white-space: normal !important;\n  margin-top: -10px !important;\n  margin-bottom: 10px !important;\n  font-weight: bold !important;\n  letter-spacing: 0.6px !important;\n  color: white !important;\n}\n.impersonate-name {\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-family: TwCenMTStd-SemiBold !important;\n  line-height: 16px !important;\n  white-space: normal !important;\n}\n.stop-btn {\n  background-color: $white-color !important;\n  border-radius: 10px !important;\n  padding: 0px 13px !important;\n  cursor: pointer !important;\n}\n.stop-name {\n  color: red !important;\n  font-size: 15px !important;\n  font-family: TwCenMTStd-SemiBold !important;\n  font-weight: bold !important;\n  margin-top: 3px !important;\n}\n.stop-divider {\n  margin: 0px 10px !important;\n  height: 20px !important;\n  width: 2px !important;\n  background: #5c5c5c !important;\n}\n.tooltip-text {\n  color: $white-color !important;\n  font-size: 15px !important;\n  font-family: TwCenMTStd-SemiBold !important;\n  font-weight: bold !important;\n  line-height: 20px !important;\n}\n\n.forgot-password-blue {\n  color: $blue-color !important;\n  font-size: 15px !important;\n  letter-spacing: 1px !important;\n  line-height: 24px;\n  cursor: pointer !important;\n  text-decoration: underline !important;\n  font-family: TwCenMTStd-SemiMedium !important;\n  text-decoration: underline;\n}\n\n.rmenu1 {\n  z-index: 1000;\n  position: absolute;\n  background-color: #ffffff;\n  box-shadow: 10px salmon;\n  // padding: 5px;\n  display: block;\n  margin: 0;\n  list-style-type: none;\n  list-style: none;\n  // left: 382px;\n  // top: 234px;\n  // cursor: pointer;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  // padding-right: 10px;\n  // padding-left: 10px;\n}\n","$theme-coclor: #c3d34f;\n$theme-coclor-disabled: #a3b32f;\n$white-color: #ffffff;\n$label-color: #171a33;\n$border-color: #e8e8e8;\n$grey-color: #979598;\n$lightgray-color: rgb(118,118,128,0.12);\n$blue-color: #344A5C;\n$admin-color: #263673;\n$pop-color: #241a2e;\n$red-color: #a70d0d;\n$red-color-disabled: #870000;\n$purple-color: #c60c68;\n$divider-color: #e8e8e8;\n$save-color: #0061ff;\n$red-link-color: #db2426;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
